function customDebounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

let pc1 = "NA";
let pc2 = "NA";
function setPincodeVariable(){
if(localStorage.customerPincode != "" && localStorage.customerPincode != null && localStorage.customerPincode != undefined){
  pc1 = `PC${localStorage.customerPincode.slice(0,3)}`;
  pc2 = `PC${localStorage.customerPincode.slice(-3)}`;
}else if(document.body.classList.contains("logged") && document.body.dataset.customerPincode != undefined && document.body.dataset.customerPincode != ""){
  pc1 = `PC${document.body.dataset.customerPincode.slice(0,3)}`;
  pc2 = `PC${document.body.dataset.customerPincode.slice(-3)}`;
}
if(localStorage.customerPincode == "" || localStorage.customerPincode == null || localStorage.customerPincode == undefined){
  pc1 = "NA";
  pc2 = "NA";
}
}
setPincodeVariable();


if(document.body.dataset.customerPincode || document.body.classList.contains("logged") ){
  pc1 = `PC${document.body.dataset.customerPincode.slice(0,3)}`;
  pc2 = `PC${document.body.dataset.customerPincode.slice(-3)}`;
}

console.log("pcccccccccc",pc1,pc2);

function customGetUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

var loggedin;

if ($("body").hasClass("logged")) {
  loggedin = "logged_in";
} else {
  loggedin = "guest";
}
// user id
if ($("body").hasClass("logged")) {
  var user_id_string = __st.cid;
  var user_id = user_id_string.toString();
} else {
  var user_id = "NA";
}

// url
var currentURL = window.location.href;

// cookie create
function createCookie(name, value, days) {
  var expires;

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  if (value != undefined) {
    document.cookie =
      encodeURIComponent(name) +
      "=" +
      encodeURIComponent(value) +
      expires +
      "; path=/";
  }
}

function readCookie(name) {
  var nameEQ = encodeURIComponent(name) + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0)
      return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name, "", -1);
}

// view_item_list
let itemProducts = [];
let item_list_nameNEW, item_list_idNEW;
function registerProductsImpression(line_item) {
  // console.log("line_item",line_item);
  var item_list_name, item_list_id;
  if (line_item.closest(".CollectionMain").length > 0 || (line_item.closest("section").length > 0 && line_item.closest("section").find(".SectionHeader__Heading").length > 0)) {
    item_list_name = line_item.closest("section").find(".SectionHeader__Heading").first().text() || line_item.parents(".ProductListWrapper").parents(".CollectionInner").parents(".CollectionMain").find(".SectionHeader__Heading").text() || line_item.closest(".collection-page-main").find(".collTitle").text();
    item_list_id = line_item.parents(".TabPanel").parents(".featured_collections").attr("data-section-id") || line_item.closest("main").find(".banner_prod").attr("id") || $(line_item).parents(".Product").parents(".pdp-rec,.product-recommendations,.pair_with_section").attr("id") || line_item.parents(".shopify-section").attr("id");
  }
  var products = [];
  var imageWrapper = $(line_item).find(".ProductItem__ImageWrapper");
  if (imageWrapper.length == 0) {
    return;
  }
  var line_item_attr = JSON.parse($(line_item).find(".ProductItem__ImageWrapper").attr("data-product"));
  $(line_item).addClass("gtm-pushed");
  var product = {};
  product.item_name = line_item_attr.title;
  product.item_variant = "NA";
  if($("body.template-collection:not(.temp_promo-banner-1)").length > 0){
    product.item_name = $(line_item).find(".ProductItem__Title a").text();
    let vari = line_item_attr.title.split(" / ");
    if(vari.length > 1){
      product.item_variant = vari[1];
    }
  }
  product.item_id = line_item.find(".product_sku_id").text() || line_item_attr.sku;
  var priceString = line_item_attr.price_min;
  var priceNumeric = parseInt(priceString);
  product.price = priceNumeric;
  product.item_brand = "Bombay Shirt Company";
  
  product.item_category = line_item_attr.product_type;
  product.item_category2 = line_item_attr.occassion ? line_item_attr.occassion : 'NA';
  product.item_category3 = line_item_attr.pattern ? line_item_attr.pattern : 'NA';
  product.item_category4 = document.body.classList.contains("template-collection") ? $(`#collection-sort-popover .Popover__Value.is-selected`).text().trim() : 'NA';
  product.item_category5 = line_item_attr.colour ? line_item_attr.colour : 'NA';

  var dis;
  // var orPrice = $(line_item).find(".ProductItem__Info").find(".ProductItem__Price.Price--compareAt span").attr("data-original-value") / 100;
  var orPrice = parseInt($(line_item).find(".ProductItem__Info").find(".ProductItem__Price.Price--compareAt span").text().replace(",","").replace("₹",""));
  if (orPrice > 0) {
    dis = orPrice - product.price;
  }
  product.discount = dis ? dis : 0;
  product.item_list_name = item_list_name;
  product.item_list_id = item_list_id;

  product.index = parseInt($(line_item).index() + 1);
  product.quantity = 1;  
  products.push(product);
  itemProducts.push(product);
  item_list_nameNEW = item_list_name;
  item_list_idNEW = item_list_id;
}
// view_item_list -- END

let itemProductsSearch = [];
let item_list_nameSEACRH, item_list_idSEACRH;
function registerProductsImpressionSearch(line_item) {
  // alert("Hii");
  console.log("registerProductsImpressionSearch",line_item);

  $(line_item).addClass("gtm-pushed");

  var item_list_name = "Search Page";
  var id = $(line_item).parents(".st-container").attr("id");
  var index = parseInt($(line_item).index() + 1);
  var item_list_id = id + "_" + index;
  var item_name = $(line_item).find(".st-product-details").find(".st-product-name a").text();
  // var Price = $(line_item).find(".st-product-details").find(".st_price").text();
  var price = parseFloat($(line_item).find(".st-product-details").find(".st-product-price").find(".new-price").text().replace("₹","").replace(",","").trim());
  var orPrice = parseFloat($(line_item).find(".st-product-details").find(".st-product-price").find(".old-price").text().replace("₹","").replace(",","").trim());
  // console.log("orPrice",orPrice,price);
  if (orPrice > 0) {
    var dis = orPrice - price;
  }

  var discount = dis ? dis : "NA";
  var item_category = $(line_item).find(".st_protype").text().trim();
  var item_category2 = "NA";
  var item_category3 = "NA";
  var item_category4 = "NA";
  var item_category5 = "NA";
  var sku = $(line_item).find(".st-product-details").find(".st_sku").text();
  var productData = JSON.parse(sku);
  var item_id = productData[0].sku;
  var variants = productData[0].title;
  var parts = variants.split("/");
  var variant = parts[1] ? parts[1].trim() : "NA";
  var item_varirant = variant ? variant : "NA";

  var itemPro = {
    item_name: item_name,
    item_id: item_id,
    item_brand: "Bombay Shirt Company", //Product Brand. Example:-(Type : String)
    item_category: item_category,
    item_category2: item_category2,
    item_category3: item_category3,
    item_category4: item_category4,
    item_category5: item_category5,
    price: price,
    discount: discount,
    item_list_name: item_list_name,
    item_list_id: item_list_id,
    item_variant: item_varirant,
    index: index,
    quantity: 1,
  }
  itemProductsSearch.push(itemPro);
  // console.log("itemProductsSearch",itemProductsSearch);
  item_list_nameSEACRH = item_list_name;
  item_list_idSEACRH = item_list_id;
  // localStorage.setItem("item_list_idSEACRH",item_list_idSEACRH)
}

jQuery(document).ready(function () {
  var lstWrapper,
    grid_Cell,
    offsetTop,
    windowScrollTop,
    winOffset,
    timeout,
    elementsStickHeight,
    lstWrapper,
    pageHeader,
    pageHeaderHt,
    gridCellClassNamesList,
    winScrollWidth;

  var isALARenderedSearch;
  function ALAcheckSearch() {
    console.log("ALAcheckSearch");
    isALARenderedSearch = setInterval(function () {
      customALASearch();
    }, 2000);
  }
  ALAcheckSearch();
  function customALASearch() {
    // console.log("customALASearch");
    if ($("body.searchtap").length > 0) {
      clearInterval(isALARenderedSearch);
      gridCellClassNamesList = ".st-product-wrap";
      elementsStickHeight = $("#section-header, .CollectionToolbar").height();
      lstWrapper = $("#st-searchModal");
      pageHeader = $("#shopify-section-header");
      pageHeaderHt = pageHeader.length > 0 ? pageHeader.outerHeight() : 0;
      grid_Cell = lstWrapper.find(gridCellClassNamesList);
      // console.log("grid_Cell 260",lstWrapper, grid_Cell);
      // if(lstWrapper && lstWrapper.length > 0 && grid_Cell.length > 0) {
      //   updateBindings();
      //   scrollTrigger();
      //   console.log("scroll screen6");
      // }

      (function (history) {
        var pushState = history.pushState;
        history.pushState = function (state) {
          if (typeof history.onpushstate == "function") {
            history.onpushstate({ state: state });
          }
          return pushState.apply(history, arguments);
        };
      })(window.history);

      window.onpopstate = history.onpushstate = function (e) {
        if (e && e.state && e.state.param) {
          setTimeout(function () {
            if (lstWrapper.find(gridCellClassNamesList).length > 0) {
              console.log("grid_Cell 281", grid_Cell);
              grid_Cell = lstWrapper.find(gridCellClassNamesList);
              console.log("grid_Cell 283", grid_Cell);
              updateBindings();
            }
          }, 1000);
        }
      };

      window.addEventListener("scroll", function (e) {
        if (lstWrapper.length > 0) {
          elementsStickHeight = $("#section-header, .CollectionToolbar").height();
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            updateBindings();
            scrollTrigger();
            // console.log("scroll screen5",lstWrapper,"grid_Cell",grid_Cell);
          }, 10);
        }
      });

      $(".ProductList--carousel").on("scroll", function (e) {
        var chilrens = $(this).children(".Carousel__Cell");
        if (chilrens.length > 0) {
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            // console.log("scrolled pdpLIST carousel");
            updateBindings();
            scrollTrigger();
          }, 10);
        }
      });
    }
  }


if ($("body.template-search").length == 0) {
  $(window).on("load", function (event) {
    // .Carousel__Cell:not(.Carousel__Cell-custom),
    gridCellClassNamesList =
      `.custom-video-with-text .video-with-text-wrp,
      .index-video-img-inner,
      .app_block_main-inner_block,
      .feature-columns-slider .Grid__Cell,
      .boost-pfs-filter-products .Grid__Cell,
      .banner_prod .Grid__Cell,
      .Carousel__Cell:not(.Carousel__Cell-custom),
      .tabs-main-item[style="display: block;"] .Carousel__Cell,
      .pdp-rec .Carousel__Cell,
      .product-recommendations .Carousel__Cell,
      .CollectionItem,
      .looking-more,
      .hero-content,
      Slideshow__Slide,
      .pair_with_products .ProductItem,
      .categriy-block,
      .custom_Grid__Cell,
      .imgtext_cell,
      .banner_data,
      .sort-location`;

    elementsStickHeight = $("#section-header, .CollectionToolbar").height();

    lstWrapper = $(".shopify-section");

    pageHeader = lstWrapper.closest("section").find(".PageHeader, .SectionHeader");
    pageHeaderHt = pageHeader.length > 0 ? pageHeader.outerHeight() : 0;
    grid_Cell = lstWrapper.find(gridCellClassNamesList);

    // if(lstWrapper && lstWrapper.length > 0 && grid_Cell.length > 0) {
    //   updateBindings();
    //   scrollTrigger();
    //   console.log("scroll screen3");
    // }

    // Triggers on page navigation for collection listing
    (function (history) {
      var pushState = history.pushState;
      history.pushState = function (state) {
        if (typeof history.onpushstate == "function") {
          history.onpushstate({ state: state });
        }
        return pushState.apply(history, arguments);
      };
    })(window.history);

    window.onpopstate = history.onpushstate = function (e) {
      if (e && e.state && e.state.param) {
        setTimeout(function () {
          if (lstWrapper.find(gridCellClassNamesList).length > 0) {
            grid_Cell = lstWrapper.find(gridCellClassNamesList);
            updateBindings();
          }
        }, 1000);
      }
    };
    
    $(window).scroll(function () {
      if (lstWrapper.length > 0) {
        elementsStickHeight = $("#section-header, .CollectionToolbar").height();
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          updateBindings();
          scrollTrigger();
          // console.log("scroll screen2");
        }, 10);
      }
    });

    $(".ProductList--carousel").on("scroll", function (e) {
      var chilrens = $(this).children(".Carousel__Cell");
      if (chilrens.length > 0) {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          updateBindings();
          scrollTrigger();
          // console.log("scroll screen1");
        }, 10);
      }
    });
  });
}

  function updateBindings() {
    grid_Cell = lstWrapper.find(gridCellClassNamesList);
    offsetTop = grid_Cell.length ? grid_Cell.offset().top : 0;
    var winHt = $(window).height();
    var winScroll = $(window).scrollTop();
    windowScrollTop = offsetTop < winHt ? Math.ceil(winScroll + offsetTop) : Math.ceil(winScroll + winHt / 1 + elementsStickHeight + pageHeaderHt);
    winScrollWidth = $(window).width();
    grid_Cell.each((counter) => {
      var gridCell = grid_Cell.eq(counter);
      if (!gridCell.attr("data-offset")) {
        gridCell.attr("data-offset", Math.round(gridCell.offset().top)).attr("data-offsetheight",Math.round(gridCell.offset().top + gridCell.outerHeight()));
      }
    });
    // console.log("updateBindings",grid_Cell);
  }

  function scrollTrigger() {
    // console.log("scrollTrigger>>>>",grid_Cell);

    if (grid_Cell.length > 0) {
      var promotionImpressionCollection = [];
      var products = [];
      itemProducts = [];
      itemProductsSearch = [];
      // console.log("grid_Cell",grid_Cell);
      grid_Cell.each(function (index) {
        var gridCell = grid_Cell.eq(index);
        var gridOffset = gridCell.attr("data-offset");
        var gridOffsetheight = gridCell.attr("data-offsetheight");
        var gridCellOffsetLeft = $(gridCell).offset().left;

        if (windowScrollTop >= gridOffset && windowScrollTop <= gridOffsetheight && gridCellOffsetLeft <= winScrollWidth) {
          if (!gridCell.hasClass("gtm-pushed")) {
            if (
              !gridCell.hasClass("CollectionItem") &&
              !gridCell.hasClass("Slideshow__Slide") &&
              !gridCell.hasClass("hero-content") &&
              !gridCell.hasClass("categriy-block") &&
              !gridCell.hasClass("custom_Grid__Cell") &&
              !gridCell.hasClass("imgtext_cell") &&
              !gridCell.hasClass("banner_data") &&
              !gridCell.hasClass("looking-more") &&
              !gridCell.hasClass("video-with-text-wrp") &&
              !gridCell.hasClass("app_block_main-inner_block") &&
              !gridCell.hasClass("index-video-img-inner")
            ) {
              if ($("body").hasClass("searchtap")) {
                registerProductsImpressionSearch(gridCell);
              } else {
                // console.log("registerProductsImpression");
                registerProductsImpression(gridCell);
              }
            } else {
              if (gridCell.hasClass("Slideshow__Slide")) {
                var promotion_id = $(gridCell).parents(".Slideshow").parents(".shopify-section--slideshow").attr("id");
                var promotion_name = $(gridCell).find(".Slideshow__Content").find(".SectionHeader__Heading").text();
                if(promotion_name == "" || promotion_name == null || promotion_name == undefined){
                  console.log("slide",$(gridCell));
                  promotion_name = $(gridCell).find(".Slideshow__ImageContainer.hidden-phone img").attr("alt") != "" ? $(gridCell).find(".Slideshow__ImageContainer.hidden-phone img").attr("alt") : "BSC";
                }
                var promotion_sub_name = $(gridCell).find(".Slideshow__Content").find(".SectionHeader__SubHeading").text().trim();
                var mainDivPosition = $(gridCell).closest("section").closest("div").index() + 1;
                var childElePos = $(gridCell).index() + 1;
                var creative_slot = mainDivPosition + "|" + childElePos;
                var creative_name = promotion_name;
              }else if (gridCell.hasClass("custom_Grid__Cell")) {
                var promotion_id = $(gridCell).attr("block_id");
                var promotion_name = $(gridCell).find(".coll-desc").find(".Heading").text().trim();
                var mainDivPosition = $(gridCell).closest("section").length == 0 ? $(gridCell).closest(".shopify-section").index() : $(gridCell).closest("section").index("section");
                var childElePos = $(gridCell).index() + 1;
                var creative_slot = mainDivPosition + "|" + childElePos;
                var creative_name = `${promotion_name} - ${$(gridCell).find(".coll-desc").find(".SectionHeader__Description p").text().trim()}`;
              }else if (gridCell.hasClass("imgtext_cell")) {
                var promotion_id = $(gridCell).attr("data-id");
                var promotion_name = $(gridCell).find(".home-imgtext-content p").text().trim();
                var mainDivPosition = $(gridCell).closest("section").length == 0 ? $(gridCell).closest(".shopify-section").index() : $(gridCell).closest("section").index("section");
                var childElePos = $(gridCell).index() + 1;
                var creative_slot = mainDivPosition + "|" + childElePos;
                var creative_name = promotion_name;
              }else if (gridCell.hasClass("banner_data")) {
                var promotion_id = $(gridCell).parents(".banner_prod").attr("id");
                var promotion_name = $(gridCell).find(".coll-desc").find(".desk_").text().trim();
                var mainDivPosition = $(gridCell).closest("section").length == 0 ? $(gridCell).closest(".shopify-section").index() : $(gridCell).closest("section").index("section");
                var childElePos = $(gridCell).index() + 1;
                var creative_slot = mainDivPosition + "|" + childElePos;
                var creative_name = promotion_name;
              }else if (gridCell.hasClass("looking-more")) {
                var promotion_id = $(gridCell).attr("look_id");
                var promotion_name = $(gridCell).find(".text a").text().trim();
                var mainDivPosition = $(gridCell).closest("section").length == 0 ? $(gridCell).closest(".shopify-section").index() : $(gridCell).closest("section").index("section");
                var childElePos = $(gridCell).index() + 1;
                var creative_slot = mainDivPosition + "|" + childElePos;
                var creative_name = $(gridCell).parents(".looking-slider").parents(".Product").find(".SectionHeader__Heading").text().trim();
              }else if (gridCell.hasClass("video-with-text-wrp")) {                
                var promotion_id = $(gridCell).parents(".shopify-section").attr("id");
                var promotion_name = $(gridCell).find(".video-with-text_video_wrp img").attr("alt") != "" ? $(gridCell).find(".video-with-text_video_wrp img").attr("alt") : "BSC";
                var mainDivPosition = $(gridCell).closest(".shopify-section").index() + 1;
                var childElePos = $(gridCell).index() + 1;
                var creative_slot = mainDivPosition + "|" + childElePos;
                var creative_name = promotion_name;
              }else if (gridCell.hasClass("app_block_main-inner_block")) {
                var promotion_id = $(gridCell).parents(".shopify-section").attr("id");
                var promotion_name = "Shop with Mobile App";
                var mainDivPosition = $(gridCell).closest(".shopify-section").index() + 1;
                var childElePos = $(gridCell).index() + 1;
                var creative_slot = mainDivPosition + "|" + childElePos;
                var creative_name = promotion_name;
              }else if (gridCell.hasClass("index-video-img-inner")) {
                var promotion_id = $(gridCell).parents(".shopify-section").attr("id");
                var promotion_name = $(gridCell).find(".right_ h4") ? $(gridCell).find(".right_ h4").text().trim() : "BSC";
                var mainDivPosition = $(gridCell).closest(".shopify-section").index() + 1;
                var creative_slot = mainDivPosition + "|1";
                var creative_name = promotion_name;
              }
              
              var ecomObject = {
                promotion_id: promotion_id ? promotion_id.replace("shopify-section-template--","") : promotion_id,
                promotion_name: promotion_name.trim(),
                creative_slot: creative_slot.replace(/^['"]|['"]$/g,'').replace(/\s*\|\s*/g,'|').replace(/\s+/g,' ').trim(),
                creative_name: creative_name.trim(),
              };
              // Mark the products as pushed
              $(gridCell).addClass("gtm-pushed");

              promotionImpressionCollection.push(ecomObject);
            }
          } // if(!gridCell.hasClass('gtm-pushed')){}
        } // if( windowScrollTop >= gridOffset && windowScrollTop <= gridOffsetheight && gridCellOffsetLeft <= winScrollWidth){}
      }); // grid_Cell.each(function(index){})
      // loop end

      // Push combined promotion data to dataLayer
      if (promotionImpressionCollection.length > 0) {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          event: "view_promotion_ce",
          user_type_event: loggedin,
          User_ID_event: user_id,
          PC1: pc1,
          PC2: pc2,
          ecommerce: {
            items: promotionImpressionCollection,
          },
        });
      }

      // console.log("loopEND",itemProducts);
      if(itemProducts.length > 0){
        // console.log("loopEND SEACRH 111");
        // console.log("loopEND",itemProducts);
        var tempDataLayer = {
          event: "view_item_list_ce",
          user_type_event: loggedin,
          User_ID_event: user_id,
          item_list_name: item_list_nameNEW,
          item_list_id: item_list_idNEW,
          PC1: pc1,
          PC2: pc2,
          ecommerce: {
            currency: "INR",
            items: itemProducts,
          },
        };
        dataLayer.push(tempDataLayer);
      }

      if(itemProductsSearch.length > 0){
        console.log("loopEND SEACRH 222");
        // console.log("loopEND SEACRH",itemProductsSearch);
        var tempDataLayer = {
          event: "view_item_list_ce",
          user_type_event: loggedin,
          User_ID_event: user_id,
          item_list_name: item_list_nameSEACRH,
          item_list_id: item_list_idSEACRH,
          PC1: pc1,
          PC2: pc2,
          ecommerce: {
            currency: "INR",
            items: itemProductsSearch,
          },
        };
        dataLayer.push(tempDataLayer);
      }
      // console.log("tempDataLayer",itemProductsSearch);
      
    } // if(grid_Cell.length > 0) {}
  }
});

// 12.select_promotion
$(document).on("click", ".Slideshow .Slideshow__Slide", function () {
  var promotion_id = $(this).parents(".Slideshow").parents(".shopify-section--slideshow").attr("id");
  var promotion_name = $(this).find(".Slideshow__Content").find(".SectionHeader__Heading").text();
  if(promotion_name == "" || promotion_name == null || promotion_name == undefined){
    console.log("slide",$(this));
    promotion_name = $(this).find(".Slideshow__ImageContainer.hidden-phone img").attr("alt") != "" ? $(this).find(".Slideshow__ImageContainer.hidden-phone img").attr("alt") : "BSC";
  }
  var promotion_sub_name = $(this).find(".Slideshow__Content").find(".SectionHeader__SubHeading").text().trim();
  var mainDivPosition = $(this).closest("section").closest("div").index() + 1;
  var childElePos = $(this).index() + 1;
  var creative_slot = mainDivPosition + "|" + childElePos;
  var creative_name = promotion_name;

  var objClickevent = {
    promotion_id: promotion_id ? promotion_id.replace("shopify-section-template--","") : promotion_id,
    promotion_name: promotion_name,
    creative_slot: creative_slot,
    creative_name: creative_name,
  };
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_promotion_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      items: [objClickevent],
    },
  });
});


$(document).on("click", "[data-promotion-section] [data-promotion-list-slide]", function () {
  // console.log("aaaaaaaaaaaaaaaa");
  var promotion_id = $(this).attr("data-promotion-list-slide");
  var promotion_name = $(this).find("[data-promotion-list-slide-heading]").text() ? $(this).find("[data-promotion-list-slide-heading]").text().trim() : "BSC";
  var mainDivPosition = $(this).closest(".shopify-section").index() + 1;
  var childElePos = $(this).index() + 1;
  var creative_slot = mainDivPosition + "|" + childElePos;
  var creative_name = `${promotion_name}${$(this).find("[data-promotion-list-slide-text]").text() != "" ? " - " + $(this).find("[data-promotion-list-slide-text]").text().trim() : ""}`;

  var objClickevent = {
    promotion_id: promotion_id ? promotion_id.replace("shopify-section-template--","").replace("template--","") : promotion_id,
    promotion_name: promotion_name,
    creative_slot: creative_slot,
    creative_name: creative_name,
  };
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_promotion_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      items: [objClickevent],
    },
  });
});


$(document).on("click", ".hr-main .Grid .Grid__Cell", function () {
  // alert("Hii");
  var promotion_id = $(this).attr("block_id");
  var promotion_name = $(this).find(".coll-desc").find(".Heading").text() ? $(this).find(".coll-desc").find(".Heading").text() : "BSC";
  var mainDivPosition = $(this).closest("section").length == 0 ? $(this).closest(".shopify-section").index() : $(this).closest("section").index("section");
  var childElePos = $(this).index() + 1;
  var creative_slot = mainDivPosition + "|" + childElePos;
  var creative_name = promotion_name;

  var objClickevent = {
    promotion_id: promotion_id ? promotion_id.replace("shopify-section-template--","") : promotion_id,
    promotion_name: promotion_name,
    creative_slot: creative_slot,
    creative_name: creative_name,
  };
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_promotion_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      items: [objClickevent],
    },
  });
  // console.log(dataLayer);
});

$(document).on("click", ".home-imgtext-block-shopify-section .home-imgtext-item", function () {
  // alert("Hii");
  var promotion_id = $(this).attr("data-id");
  var promotion_name = $(this).find(".home-imgtext-content p").text() ? $(this).find(".home-imgtext-content p").text() : "BSC";
  var mainDivPosition = $(this).closest("section").length == 0 ? $(this).closest(".shopify-section").index() : $(this).closest("section").index("section");
  var childElePos = $(this).index() + 1;
  var creative_slot = mainDivPosition + "|" + childElePos;
  var creative_name = promotion_name;

  var objClickevent = {
    promotion_id: promotion_id ? promotion_id.replace("shopify-section-template--","") : promotion_id,
    promotion_name: promotion_name,
    creative_slot: creative_slot,
    creative_name: creative_name,
  };
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_promotion_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      items: [objClickevent],
    },
  });
  // console.log(dataLayer);
});

$(document).on("click",".template-collection .CollectionInner .banner_prod .TabPanel",function () {
  var promotion_id = $(this).parents(".banner_prod").attr("id");
  var promotion_name = $(this).find(".coll-desc").find(".desk_").text() ? $(this).find(".coll-desc").find(".desk_").text() : "BSC";
  var mainDivPosition = $(this).closest("section").length == 0 ? $(this).closest(".shopify-section").index() : $(this).closest("section").index("section");
  var childElePos = $(this).index() + 1;
  var creative_slot = mainDivPosition + "|" + childElePos;
  var creative_name = promotion_name;

  var objClickevent = {
    promotion_id: promotion_id ? promotion_id.replace("shopify-section-template--","") : promotion_id,
    promotion_name: promotion_name,
    creative_slot: creative_slot,
    creative_name: creative_name,
  };
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_promotion_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      items: [objClickevent],
    },
  });
  // console.log(dataLayer);
});

$(document).on("click",".pair_with_products .looking-slider .looking-more",function () {
  var promotion_id = $(this).attr("look_id");
  var promotion_name = $(this).find(".text a").text() ? $(this).find(".text a").text() : "BSC";
  var mainDivPosition = $(this).closest("section").length == 0 ? $(this).closest(".shopify-section").index() + 1 : $(this).closest("section").index("section");
  var childElePos = $(this).index() + 1;
  var creative_slot = mainDivPosition + "|" + childElePos;
  var creative_name = $(this).parents(".looking-slider").parents(".Product").find(".SectionHeader__Heading").text();

  var objClickevent = {
    promotion_id: promotion_id ? promotion_id.replace("shopify-section-template--","") : promotion_id,
    promotion_name: promotion_name,
    creative_slot: creative_slot,
    creative_name: creative_name,
  };
  // console.log(objClickevent , 'objClickevent2');
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_promotion_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      items: [objClickevent],
    },
  });
  // console.log(dataLayer);
});

$(document).on("click",".section-video-with-text",function () {
  var promotion_id = $(`.shopify-section.section-video-with-text`).attr("id");
  // var promotion_name = $(`.section-video-with-text .video-with-text_video_wrp img`).text() ? $(this).find(".text a").text() : "BSC";
  var promotion_name = $(`.section-video-with-text .video-with-text_video_wrp img`).attr("alt") != "" ? $(`.section-video-with-text .video-with-text_video_wrp img`).attr("alt") : "BSC";
  var mainDivPosition = $(`.section-video-with-text`).index() + 1;
  var childElePos = 1;
  var creative_slot = mainDivPosition + "|" + childElePos;
  var creative_name = promotion_name;

  var objClickevent = {
    promotion_id: promotion_id ? promotion_id.replace("shopify-section-template--","") : promotion_id,
    promotion_name: promotion_name,
    creative_slot: creative_slot,
    creative_name: creative_name,
  };
  // console.log(objClickevent , 'objClickevent2');
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_promotion_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      items: [objClickevent],
    },
  });
  // console.log(dataLayer);
});

$(document).on("click",".section-index-video-img",function () {
  var promotion_id = $(`.shopify-section.section-index-video-img`).attr("id");
  var promotion_name = $(`.section-index-video-img .right_ h4`) != "" ? $(`.section-index-video-img .right_ h4`).text().trim() : "BSC";
  var mainDivPosition = $(`.section-index-video-img`).index() + 1;
  var creative_slot = mainDivPosition + "|1";
  var creative_name = promotion_name;

  var objClickevent = {
    promotion_id: promotion_id ? promotion_id.replace("shopify-section-template--","") : promotion_id,
    promotion_name: promotion_name,
    creative_slot: creative_slot,
    creative_name: creative_name,
  };
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_promotion_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      items: [objClickevent],
    },
  });
  // console.log(dataLayer);
});

$(document).on("click",".shopify-section.app_block_main",function () {
  var promotion_id = $(this).attr("id");
  var promotion_name = "Shop with Mobile App";
  var mainDivPosition = $(`.shopify-section.app_block_main`).index() + 1;
  var childElePos = 1;
  var creative_slot = mainDivPosition + "|" + childElePos;
  var creative_name = promotion_name;

  var objClickevent = {
    promotion_id: promotion_id ? promotion_id.replace("shopify-section-template--","") : promotion_id,
    promotion_name: promotion_name,
    creative_slot: creative_slot,
    creative_name: creative_name,
  };
  // console.log(objClickevent , 'objClickevent2');
  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_promotion_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      items: [objClickevent],
    },
  });
  // console.log(dataLayer);
});

//13.select_item
$(document).on("click",".featured-collections .ProductList .Carousel__Cell",function () {
  var line_item = $(this).find(".ProductItem__ImageWrapper");
  var line_item_attr = JSON.parse($(line_item).attr("data-product"));

  var products = [];
  // Preparing the clicked product
  var product = {};
  product.item_name = line_item_attr.title;
  product.item_id = line_item_attr.variants.sku;
  product.price = parseInt(line_item_attr.price_min);
  product.item_brand = "Bombay Shirt Company";
  var variants = line_item_attr.variants.title ? line_item_attr.variants.title : "NA";
  var parts = variants.split("/");
  var variant = parts[1];
  product.item_variant = "NA";
  product.item_category = line_item_attr.product_type;
  product.item_category2 = line_item_attr.occassion ? line_item_attr.occassion : 'NA';
  product.item_category3 = line_item_attr.pattern ? line_item_attr.pattern : 'NA';
  product.item_category4 = "NA";
  product.item_category5 = line_item_attr.colour ? line_item_attr.colour : 'NA';
  var orPrice = $(this).find(".ProductItem__Info").find(".ProductItem__Price.Price--compareAt span").text();
  if (dis > 0) {
    var dis = orPrice - product.price;
  }
  product.discount = dis ? dis : 0;
  let handle = line_item_attr.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

  let listName = $(this).closest(".shopify-section").find(".SectionHeader__Heading").text().replace($(this).closest(".shopify-section").find(".SectionHeader__Heading .pro-count").text(),"");
  localStorage.setItem(`ga_${line_item_attr.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}`,listName);

  product.item_list_name = listName;
  product.item_list_id = $(this).closest(".shopify-section").attr("id").replace("shopify-section-template--","");
  product.index = parseInt(readCookie("index"));
  product.quantity = 1;
  products.push(product);
  // console.log(product, "product");

  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_item_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    item_list_name: listName,
    item_list_id: $(this).closest(".shopify-section").attr("id").replace("shopify-section-template--",""),
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      currency: "INR",
      items: products,
    },
  });
});


$(document).on("click",".ProductListWrapper .boost-pfs-filter-products .Grid__Cell",function () {
  
  var line_item = $(this).find(".ProductItem__ImageWrapper");
  var line_item_attr = JSON.parse($(line_item).attr("data-product"));

  var products = [];
  // Preparing the clicked product
  var product = {};
  product.item_name = $(this).find(".ProductItem__Title a").text();
  product.item_variant = 'NA';
  
  product.item_id = $(this).find(".product_sku_id").text();
  product.price = parseInt(line_item_attr.price_min);
  product.item_brand = "Bombay Shirt Company";
  product.item_category = line_item_attr.product_type;
  product.item_category2 = line_item_attr.occassion ? line_item_attr.occassion : 'NA';
  product.item_category3 = line_item_attr.pattern ? line_item_attr.pattern : 'NA';
  product.item_category4 = document.body.classList.contains("template-collection") ? $(`#collection-sort-popover .Popover__Value.is-selected`).text().trim() : 'NA';
  product.item_category5 = line_item_attr.colour ? line_item_attr.colour : 'NA';
  var orPrice = $(this).find(".ProductItem__Info").find(".ProductItem__Price.Price--compareAt span").attr("data-original-value") / 100;
  var dis;
  if (orPrice > 0) {
    dis = orPrice - product.price;
  }
  product.discount = dis ? dis : 0;

  let listName = $(".collection-page-main .collTitle").text();
  localStorage.setItem(`ga_${$(this).find(".ProductItem__Title a").text().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}`,listName);

  product.item_list_name = $(".collection-page-main .collTitle").text();
  product.item_list_id = $(this).closest(".shopify-section").attr("id").replace("shopify-section-template--","");
  product.index = $(this).index() + 1;
  product.quantity = 1;
  products.push(product);

  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_item_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    item_list_name: $(".collection-page-main .collTitle").text(),
    item_list_id: $(this).closest(".shopify-section").attr("id").replace("shopify-section-template--",""),
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      currency: "INR",
      items: products,
    },
  });
});

$(document).on("click",".ProductRecommendations .ProductListWrapper .Carousel__Cell, .product-recommendations .ProductListWrapper .Carousel__Cell,.pair_with_products .product-grid .ProductItem",function () {
  console.log("ProductRecommendations PDP clicked");
  
  var line_item = $(this).find(".ProductItem__ImageWrapper");
  var line_item_attr = JSON.parse($(line_item).attr("data-product"));

  var products = [];
  // Preparing the clicked product
  var product = {};
  product.item_name = line_item_attr.title;
  product.item_id = line_item_attr.variants.sku;
  product.price = parseInt(line_item_attr.price_min);
  product.item_brand = "Bombay Shirt Company";
  var variants = line_item_attr.variants.title ? line_item_attr.variants.title : "NA";
  var parts = variants.split("/");
  var variant = parts[1];
  product.item_variant = "NA";
  product.item_category = line_item_attr.product_type;
  product.item_category2 = line_item_attr.occassion ? line_item_attr.occassion : 'NA';
  product.item_category3 = line_item_attr.pattern ? line_item_attr.pattern : 'NA';
  product.item_category4 = document.body.classList.contains("template-collection") ? $(`#collection-sort-popover .Popover__Value.is-selected`).text().trim() : 'NA';
  product.item_category5 = line_item_attr.colour ? line_item_attr.colour : 'NA';
  var orPrice = $(this).find(".ProductItem__Info").find(".ProductItem__Price.Price--compareAt span").attr("data-original-value") / 100;
  var dis;
  // console.log("orPrice",orPrice,product.price);
  if (orPrice > 0) {
    dis = orPrice - product.price;
  }
  product.discount = dis ? dis : 0;

  let listName = $(this).closest(".shopify-section").find(".SectionHeader__Heading").text();
  localStorage.setItem(`ga_${line_item_attr.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}`,listName);

  product.item_list_name = $(this).closest(".shopify-section").find(".SectionHeader__Heading").text();
  product.item_list_id = $(this).closest(".shopify-section").attr("id").replace("shopify-section-template--","");
  product.index = $(this).index() + 1;
  product.quantity = 1;
  products.push(product);
  // console.log(product, "product");

  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_item_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    item_list_name: $(this).closest(".shopify-section").find(".SectionHeader__Heading").text(),
    item_list_id: $(this).closest(".shopify-section").attr("id").replace("shopify-section-template--",""),
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      currency: "INR",
      items: products,
    },
  });
});


// remove from wishlist search page 
$(document).on("click", ".st-container .st-product-wrap .swym-button.swym-added", function (e) {
  e.stopPropagation();
  console.log("remove from wishlist search page clicked");
  // function getUrlParameter(name) {
  //   name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  //   var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  //   var results = regex.exec(location.search);
  //   return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  // }

  // Get f.Category, f.Color, and f.Occassion values from URL
  // var category_value = getUrlParameter('f.Category');
  // var pattern_value = getUrlParameter('f.Pattern');
  // var color_value = getUrlParameter('f.Color');
  // var occasion_value = getUrlParameter('f.Occassion');
  // var sort_value = getUrlParameter('sort');

  // createCookie("category_value", category_value);
  // createCookie("pattern_value", pattern_value);
  // createCookie("color_value", color_value);
  // createCookie("occasion_value", occasion_value);
  // createCookie("sort_value", sort_value);
  
  var prodData = $(this)[0].attributes[6].nodeValue;
  var mainproductData = JSON.parse(prodData);

  console.log(mainproductData,"mainproductData");
  

  var item_name = mainproductData.product_title;
  var item_ID = mainproductData.id
  var dis = "NA";
  var price = mainproductData.price_min;
  // var newcookieprice = $(this).find(".st-product-details").find(".st-product-price").find(".new-price").text().trim();
  // Decode if encoded
  // priceText = decodeURIComponent(newcookieprice);
  // Remove currency symbol and commas → keep only digits
  // priceText = newcookieprice.replace(/[^\d]/g, ""); 
  // priceTextInt = parseInt(priceText);
  // createCookie("priceprice", priceTextInt);

  var orPrice = mainproductData.price_max;
  // var newcookieorprice = $(this).find(".st-product-details").find(".st-product-price").find(".old-price").text().trim();
  // console.log("orPrice",orPrice,price);
  // Decode if encoded
  // orpriceText = decodeURIComponent(newcookieorprice);
  // Remove currency symbol and commas → keep only digits
  // orpriceText = newcookieorprice.replace(/[^\d]/g, ""); 
  // orpriceTextInt = parseInt(orpriceText);
  // createCookie("orPrice", orpriceTextInt);

  // if (orpriceTextInt > 0) {
  //   dis = orpriceTextInt - priceTextInt;
  // }

  if (orPrice > 0) {
    dis = orPrice - price;
  }
  var discount = dis;
  var item_category = mainproductData.product_type;
  var item_category2 = mainproductData.occassion ? mainproductData.occassion : "NA";
  var item_category3 = mainproductData.pattern ? mainproductData.pattern : "NA";
  var item_category4 = "NA";
  var item_category5 = mainproductData.colour ? mainproductData.colour : "NA";

  var item_id = mainproductData.sku;
  var variants = mainproductData.variant_title;
  var parts = variants.split("/");
  var variant = parts[1];
  var item_varirant = "NA";
  // product.pincode = pincode;
  let handle = item_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  createCookie(`item_list_name${handle}`,readCookie("item_list_name"));
  createCookie(`item_list_id${handle}`,readCookie("item_list_id"));
  console.log(item_name,"item_nameitem_name");
  
  // createCookie(`item_list_name`,handle);
  // createCookie(`item_list_id`,item_ID);

  let item_list_nameSEACRH;
  var item_list_sname = "Search Page";
  item_list_nameSEACRH = item_list_sname;

  if(item_list_nameSEACRH == "Search Page"){
    var itemCardParent = $(e.target).closest(".st-product-wrap").closest(".st-product-wrapper");
    var itemCard = $(e.target).closest(".st-product-wrap");
    var indexCard = parseInt(itemCardParent.find(".st-product-wrap").index(itemCard) + 1);
    item_list_ids = $(e.target).closest(".st-container") ? $(e.target).closest(".st-container").attr("id")  + "_" + indexCard : "NA";
  }

  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "remove_from_wishlist_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    item_list_name: item_list_sname ? item_list_sname : "NA",
    // item_list_id: readCookie("item_list_id"),
    item_list_id: item_list_ids ? item_list_ids : "NA",
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      currency: "INR",
      items: [
        {
          item_name: item_name,
          // item_id: item_id,
          item_id: item_ID ? item_ID : "NA",
          item_brand: "Bombay Shirt Company",
          item_category: item_category,
          item_category2: item_category2,
          item_category3: item_category3,
          item_category4: item_category4,
          item_category5: item_category5,
          price: parseInt(price),
          // price: priceTextInt ? priceTextInt : "NA",
          discount: discount ? discount : "NA",
          // item_list_name: "NA",
          // item_list_id: "NA",
          // item_list_name: item_list_nameSEACRH ? item_list_nameSEACRH : "NA",
          // item_list_id: item_list_idSEACRH ? item_list_idSEACRH : "NA",
          item_list_name: item_list_sname ? item_list_sname : "NA",
          // item_list_id: readCookie("item_list_id") ? readCookie("item_list_id") : "NA",
          item_list_id: item_list_ids ? item_list_ids : "NA",
          item_variant: item_varirant,
          index: parseInt(readCookie("index")),
          quantity: 1
          // pincode: pincode
        },
      ],
    },
  });
});


$(document).on("click", ".st-container .st-product-wrap", function () {
  // alert("clicked");
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  }

  // Get f.Category, f.Color, and f.Occassion values from URL
  var category_value = getUrlParameter('f.Category');
  var pattern_value = getUrlParameter('f.Pattern');
  var color_value = getUrlParameter('f.Color');
  var occasion_value = getUrlParameter('f.Occassion');
  var sort_value = getUrlParameter('sort');

  createCookie("category_value", category_value);
  createCookie("pattern_value", pattern_value);
  createCookie("color_value", color_value);
  createCookie("occasion_value", occasion_value);
  createCookie("sort_value", sort_value);
  
  var item_name = $(this).find(".st-product-details").find(".st-product-name a").text();
  var item_ID = $(this).find(".st-product-details").find(".st-product-name a").attr("data-product-id");
  var dis = "NA";
  var price = parseFloat($(this).find(".st-product-details").find(".st-product-price").find(".new-price").attr("data-original-value") / 100);
  var newcookieprice = $(this).find(".st-product-details").find(".st-product-price").find(".new-price").text().trim();
  // Decode if encoded
  priceText = decodeURIComponent(newcookieprice);
  // Remove currency symbol and commas → keep only digits
  priceText = newcookieprice.replace(/[^\d]/g, ""); 
  priceTextInt = parseInt(priceText);
  // createCookie("priceprice", priceTextInt);

  var orPrice = parseFloat($(this).find(".st-product-details").find(".st-product-price").find(".old-price").attr("data-original-value") / 100);
  var newcookieorprice = $(this).find(".st-product-details").find(".st-product-price").find(".old-price").text().trim();
  // console.log("orPrice",orPrice,price);
  // Decode if encoded
  orpriceText = decodeURIComponent(newcookieorprice);
  // Remove currency symbol and commas → keep only digits
  orpriceText = newcookieorprice.replace(/[^\d]/g, ""); 
  orpriceTextInt = parseInt(orpriceText);
  // createCookie("orPrice", orpriceTextInt);

  if (orpriceTextInt > 0) {
    dis = orpriceTextInt - priceTextInt;
  }

  // if (orPrice > 0) {
  //   dis = orPrice - price;
  // }
  var discount = dis;
  var item_category = readCookie("category_value") ? readCookie("category_value") : "NA";
  var item_category2 = readCookie("occasion_value") ? readCookie("occasion_value") : "NA";
  var item_category3 = readCookie("pattern_value") ? readCookie("pattern_value") : "NA";
  var item_category4 = readCookie("sort_value") ? readCookie("sort_value") : "NA";
  var item_category5 = readCookie("color_value") ? readCookie("color_value") : "NA";
  var sku = $(this).find(".st-product-details").find(".st_sku").text();
  var productData = JSON.parse(sku);
  var item_id = productData[0].sku;
  var variants = productData[0].title;
  var parts = variants.split("/");
  var variant = parts[1];
  var item_varirant = "NA";
  // product.pincode = pincode;
  let handle = item_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  createCookie(`item_list_name${handle}`,readCookie("item_list_name"));
  createCookie(`item_list_id${handle}`,readCookie("item_list_id"));
  console.log(item_name,"item_nameitem_name");
  
  // createCookie(`item_list_name`,handle);
  // createCookie(`item_list_id`,item_ID);

  let item_list_nameSEACRH;
  var item_list_sname = "Search Page";
  item_list_nameSEACRH = item_list_sname;

  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "select_item_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    item_list_name: item_list_sname ? item_list_sname : "NA",
    item_list_id: readCookie("item_list_id"),
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      currency: "INR",
      items: [
        {
          item_name: item_name,
          // item_id: item_id,
          item_id: item_ID ? item_ID : "NA",
          item_brand: "Bombay Shirt Company",
          item_category: item_category,
          item_category2: item_category2,
          item_category3: item_category3,
          item_category4: item_category4,
          item_category5: item_category5,
          // price: parseInt(price),
          price: priceTextInt ? priceTextInt : "NA",
          discount: discount ? discount : "NA",
          // item_list_name: "NA",
          // item_list_id: "NA",
          // item_list_name: item_list_nameSEACRH ? item_list_nameSEACRH : "NA",
          // item_list_id: item_list_idSEACRH ? item_list_idSEACRH : "NA",
          item_list_name: item_list_sname ? item_list_sname : "NA",
          item_list_id: readCookie("item_list_id") ? readCookie("item_list_id") : "NA",
          item_variant: item_varirant,
          index: parseInt(readCookie("index")),
          quantity: 1
          // pincode: pincode
        },
      ],
    },
  });
});


//13.add_to_wishlist
document.addEventListener("click", function(e) {
  // console.log("Document clicked", e);
  if(e.target.classList.contains("swym-button") && !e.target.classList.contains("swym-added")){
    let eventName = "add_to_wishlist_ce";
    if(e.target.closest(".Product__Info")){
      // pdp
      console.log("wishlist clicked>>>>>>>>>>>>>>>PDP iff");
      var proInfo = e.target.closest(".Product__Info");
      var products = [];
      var product = {};
      
      let item_variant = "NA";
      if($(this).closest(".ProductForm.rtw").length > 0){
        item_variant = $(this).closest(".ProductForm.rtw").find(`.SizeSwatchList [name="properties[_size]"]:checked`).val();
      }else{
        if($(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide)`).length > 0){
          if($(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide) input:checked`).val()){
            item_variant = $(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide) input:checked`).val();
          }
        }else{
          if($(this).closest(".ProductForm").find(`[data-pro-saved-sizing]:not(.hide)`).length > 0){
            item_variant = $(`[data-product-fitsmart-global] .profile_size`).text().trim();
          }
        }
      }

      product.item_name = window.productInfo.product_title;
      product.item_id = window.productInfo.variants.sku;
      product.price = parseInt(window.productInfo.product_price);
      product.item_brand = "Bombay Shirt Company";
      product.item_variant = item_variant;
      product.item_category = window.productInfo.product_type;
      product.item_category2 = window.productInfo.occassion;
      product.item_category3 = window.productInfo.pattern;
      product.item_category4 = "NA";
      product.item_category5 = window.productInfo.colour;
      var orPrice = window.productCMP ? parseInt(window.productCMP/100) : 0;
      var dis = 0;
      if (orPrice > 0) {
        dis = orPrice - product.price;
      }
      product.discount = dis;
      let handle = location.href.split("/")[location.href.split("/").length-1];

      // let item_list_nameSEACRH;
      // var item_list_sname = "Search Page";
      // item_list_nameSEACRH = item_list_sname;
      // var item_list_idSEACRH = localStorage.getItem("item_list_idSEACRH");
      
      // product.item_list_name = item_list_nameSEACRH ? item_list_nameSEACRH : "NA";
      product.item_list_name = product.item_name ? product.item_name : "NA";
      let item_list_nameadd = product.item_list_name;
      // product.item_list_id = item_list_idSEACRH ? item_list_idSEACRH : "NA";
      product.item_list_id = product.item_id ? product.item_id : "NA";
      let item_list_idadd = product.item_list_id;

      product.index = 1,
      product.quantity = 1;
      products.push(product);
      console.log(item_list_nameSEACRH, "product add_to_wishlist_ce");

      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: eventName,
        user_type_event: loggedin,
        User_ID_event: user_id,
        item_list_name: item_list_nameadd ? item_list_nameadd : "NA",
        item_list_id: item_list_idadd ? item_list_idadd : "NA",
        // item_list_name: item_list_nameSEACRH ? item_list_nameSEACRH : "NA",
        // item_list_id: item_list_idSEACRH ? item_list_idSEACRH : "NA",
        PC1: pc1,
        PC2: pc2,
        ecommerce: {
          currency: "INR",
          value: parseInt(window.productInfo.product_price),
          items: products,
        },
      });
    }else{
    // pro-card
    if(e.target.closest(".ProductItem.boost-slider")){
    console.log("wishlist clicked>>>>>>>>>>>>>>>PDP else11");
      //pro card coll page
      console.log("wishlist clicked coll page>>>>>>>>>>>>>>>");
      var line_item = e.target.closest(".ProductItem").querySelector(".ProductItem__ImageWrapper");
      var line_item_attr = JSON.parse(line_item.dataset.product);

      var products = [];
      // Preparing the clicked product
      var product = {};
      
      let item_variant = "NA";
      if($(this).closest(".ProductForm.rtw").length > 0){
        item_variant = $(this).closest(".ProductForm.rtw").find(`.SizeSwatchList [name="properties[_size]"]:checked`).val();
      }else{
        if($(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide)`).length > 0){
          if($(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide) input:checked`).val()){
            item_variant = $(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide) input:checked`).val();
          }
        }else{
          if($(this).closest(".ProductForm").find(`[data-pro-saved-sizing]:not(.hide)`).length > 0){
            item_variant = $(`[data-product-fitsmart-global] .profile_size`).text().trim();
          }
        }
      }

      product.item_name = line_item_attr.title;
      console.log("line_item_attr",line_item_attr);
      product.item_id = line_item_attr.sku ? line_item_attr.sku : "NA";
      product.price = parseInt(line_item_attr.price_min);
      product.item_brand = "Bombay Shirt Company";
      var variants = line_item_attr.variant_title ? line_item_attr.variant_title : "NA";
      var parts = variants.split("/");
      var variant = parts[1];
      product.item_variant = item_variant;
      product.item_category = line_item_attr.product_type;
      product.item_category2 = line_item_attr.occassion ? line_item_attr.occassion : 'NA';
      product.item_category3 = line_item_attr.pattern ? line_item_attr.pattern : 'NA';
      product.item_category4 = document.body.classList.contains("template-collection") ? $(`#collection-sort-popover .Popover__Value.is-selected`).text().trim() : 'NA';
      product.item_category5 = line_item_attr.colour ? line_item_attr.colour : 'NA';
      var orPrice = e.target.closest(".ProductItem").querySelector(".ProductItem__Info .ProductItem__Price.Price--compareAt") ? e.target.closest(".ProductItem").querySelector(".ProductItem__Info .ProductItem__Price.Price--compareAt").innerText.replace(",","") : null;
      console.log("orPrice",orPrice);
      if (orPrice != null) {
        var dis = orPrice - product.price;
      }
      product.discount = dis ? dis : 0;
      product.item_list_name = e.target.closest(".shopify-section").querySelector(".collTitle") ? e.target.closest(".shopify-section").querySelector(".collTitle").innerText : "NA";
      item_list_nameadd = product.item_list_name;
      product.item_list_id = e.target.closest(".shopify-section") ? e.target.closest(".shopify-section").id : "NA";
      item_list_idadd = product.item_list_id;
      product.index = 1,
      product.quantity = 1;
      products.push(product);
      // console.log(product, "product");

      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: eventName,
        user_type_event: loggedin,
        User_ID_event: user_id,
        // item_list_name: $(".collTitle").text().trim(),
        item_list_name: item_list_nameadd ? item_list_nameadd : "NA",
        // item_list_id: $(".collection-page-main").closest(".shopify-section").attr("id").replace("shopify-section-template--",""),
        item_list_id: item_list_idadd ? item_list_idadd : "NA",
        PC1: pc1,
        PC2: pc2,
        ecommerce: {
          currency: "INR",
          value: parseInt(line_item_attr.price_min),
          items: products,
        },
      });
    }else{
      $(e.target).closest('.swym-modal, .swym-container').find('.swym-close-btn').trigger('click');
      console.log("wishlist clicked>>>>>>>>>>>>>>>PDP else22",e.target);
      if(e.target.closest(".ProductItem")){
        var line_item = e.target.closest(".ProductItem").querySelector(".ProductItem__ImageWrapper");
        var line_item_attr = JSON.parse(line_item.dataset.product);
      } else {
        var line_item = e.target.closest(".st-product-wrap").querySelector(".st-product");
        var line_item_attr  = JSON.parse(line_item.dataset.product);
        console.log(line_item_attr,"line_itemstline_itemst");
      }

      var products = [];
      // Preparing the clicked product
      var product = {};
      product.item_name = line_item_attr.title;
      // product.item_id = line_item_attr.variants.sku
      product.item_id = line_item_attr.sku ? line_item_attr.sku : line_item_attr.variants.sku;
      product.price = parseInt(line_item_attr.price_min);
      product.item_brand = "Bombay Shirt Company";
      // var variants = line_item_attr.variants.title ? line_item_attr.variants.title : "NA";
      var variants = line_item_attr.title ? line_item_attr.title : line_item_attr.variants.title;
      var parts = variants.split("/");
      var variant = parts[1];
      product.item_variant = "NA";
      product.item_category = line_item_attr.product_type;
      product.item_category2 = line_item_attr.occassion ? line_item_attr.occassion : 'NA';
      product.item_category3 = line_item_attr.pattern ? line_item_attr.pattern : 'NA';
      product.item_category4 = document.body.classList.contains("template-collection") ? $(`#collection-sort-popover .Popover__Value.is-selected`).text().trim() : 'NA';
      product.item_category5 = line_item_attr.colour ? line_item_attr.colour : 'NA';
      if(e.target.closest(".ProductItem")){
        var orPrice = e.target.closest(".ProductItem").querySelector(".ProductItem__Info .ProductItem__Price.Price--compareAt span") ? e.target.closest(".ProductItem").querySelector(".ProductItem__Info .ProductItem__Price.Price--compareAt span").innerText.replace(",","") : null;
      } else {
        var orPrice = e.target.closest(".st-product-wrap").querySelector(" .st-product-price .old-price") ? e.target.closest(".st-product-wrap").querySelector(".st-product-price .old-price").innerText.replace(",","") : null;
         orPrice = parseInt(orPrice.replace(/\D/g, ""), 10);
      }
      
      // if (parseInt(orPrice) > 0) {
      if (orPrice > 0) {
        var dis = parseInt(orPrice) - product.price;
      }
      product.discount = dis ? dis : 0;
      let handle = line_item_attr.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      createCookie(`item_list_name${handle}`,readCookie("item_list_name"));
      createCookie(`item_list_id${handle}`,readCookie("item_list_id"));
      // product.item_list_name = readCookie("item_list_name");
      // product.item_list_id = readCookie("item_list_id");
      if(e.target.closest(".shopify-section")){
        product.item_list_name = e.target.closest(".shopify-section").querySelector(".SectionHeader__Heading") ? e.target.closest(".shopify-section").querySelector(".SectionHeader__Heading").innerText : "NA";
      } else {
        product.item_list_name = $(e.target).closest("#searchModalContainer").attr("class");
        if(product.item_list_name == "st-container"){
          product.item_list_name = "Search Page";
        }
      }
      console.log(product.item_list_name,"product.item_list_name");
      
      item_list_nameadd = product.item_list_name;
      if(product.item_list_name == "Search Page"){
        var itemCardParent = $(e.target).closest(".st-product-wrap").closest(".st-product-wrapper");
        var itemCard = $(e.target).closest(".st-product-wrap");
        var indexCard = parseInt(itemCardParent.find(".st-product-wrap").index(itemCard) + 1);
        product.item_list_id = $(e.target).closest(".st-container") ? $(e.target).closest(".st-container").attr("id") + "_" + indexCard  : "NA";
      } else {
        product.item_list_id = e.target.closest(".shopify-section") ? e.target.closest(".shopify-section").id : "NA";
      }
      item_list_idadd = product.item_list_id;
      product.index = 1,
      product.quantity = 1;
      products.push(product);
      // console.log(product, "product");

      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: eventName,
        user_type_event: loggedin,
        User_ID_event: user_id,
        item_list_name: item_list_nameadd ? item_list_nameadd : "NA",
        item_list_id: item_list_idadd ? item_list_idadd : "NA",
        PC1: pc1,
        PC2: pc2,
        ecommerce: {
          currency: "INR",
          value: parseInt(line_item_attr.price_min),
          items: products,
        },
      });
    }
    }
  }
}, { capture: true });


//42.remove_from_wishlist
$(document).on("click", ".Product__Info .swym-button.swym-added", function (e) {


  console.log("Document clicked remove 42", e);
  
  let eventName = "remove_from_wishlist_ce";
  if(e.target.closest(".Product__Info")){
    // pdp
    console.log("wishlist clicked>>>>>>>>>>>>>>>PDP");
    var proInfo = e.target.closest(".Product__Info");
    var products = [];
    var product = {};
    
    let item_variant = "NA";
    if($(this).closest(".ProductForm.rtw").length > 0){
      item_variant = $(this).closest(".ProductForm.rtw").find(`.SizeSwatchList [name="properties[_size]"]:checked`).val();
    }else{
      if($(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide)`).length > 0){
        if($(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide) input:checked`).val()){
          item_variant = $(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide) input:checked`).val();
        }
      }else{
        if($(this).closest(".ProductForm").find(`[data-pro-saved-sizing]:not(.hide)`).length > 0){
          item_variant = $(`[data-product-fitsmart-global] .profile_size`).text().trim();
        }
      }
    }

    product.item_name = window.productInfo.product_title;
    product.item_id = window.productInfo.variants.sku;
    product.price = parseInt(window.productInfo.product_price);
    product.item_brand = "Bombay Shirt Company";
    product.item_variant = item_variant;
    product.item_category = window.productInfo.product_type;
    product.item_category2 = window.productInfo.occassion;
    product.item_category3 = window.productInfo.pattern;
    product.item_category4 = "NA";
    product.item_category5 = window.productInfo.colour;
    var orPrice = window.productCMP ? parseInt(window.productCMP/100) : 0;
    var dis = 0;
    if (orPrice > 0) {
      dis = orPrice - product.price;
    }
    product.discount = dis;
    let handle = location.href.split("/")[location.href.split("/").length-1];

      // let item_list_nameSEACRH;
      // var item_list_sname = "Search Page";
      // item_list_nameSEACRH = item_list_sname;
      // var item_list_idSEACRH = localStorage.getItem("item_list_idSEACRH");

      product.item_list_name = window.productInfo.product_title ? window.productInfo.product_title : "NA";
      item_list_namermv = product.item_list_name;
      product.item_list_id = window.productInfo.variants.sku ? window.productInfo.variants.sku : "NA";
      item_list_idrmv = product.item_list_id
    // product.item_list_name = "NA";
    // product.item_list_id = "NA";

    product.index = 1,
    product.quantity = 1;
    products.push(product);
    console.log(product, "product");

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: eventName,
      user_type_event: loggedin,
      User_ID_event: user_id,
      item_list_name: item_list_namermv ? item_list_namermv : "NA",
      item_list_id: item_list_idrmv ? item_list_idrmv : "NA", 
      // item_list_name: "NA",
      // item_list_id: "NA",
      PC1: pc1,
      PC2: pc2,
      ecommerce: {
        currency: "INR",
        items: products,
      },
    });
  } 
});
 
$(document).on("click", ".ProductItem .swym-button.swym-added", function (e) {
  e.stopPropagation()
  console.log("Document clicked 1407", e);
  console.log(document.body.dataset.customerPincode,"document.body.dataset.customerPincode");
  let eventName = "remove_from_wishlist_ce";

  if(e.target.closest(".ProductItem.boost-slider")){
    //pro card coll page
    console.log("Document clicked if 1407", e);
    console.log("wishlist clicked coll page>>>>>>>>>>>>>>>");
    var line_item = e.target.closest(".ProductItem").querySelector(".ProductItem__ImageWrapper");
    var line_item_attr = JSON.parse(line_item.dataset.product);

    var products = [];
    // Preparing the clicked product
    var product = {};
    
    let item_variant = "NA";
    if($(this).closest(".ProductForm.rtw").length > 0){
      item_variant = $(this).closest(".ProductForm.rtw").find(`.SizeSwatchList [name="properties[_size]"]:checked`).val();
    }else{
      if($(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide)`).length > 0){
        if($(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide) input:checked`).val()){
          item_variant = $(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide) input:checked`).val();
        }
      }else{
        if($(this).closest(".ProductForm").find(`[data-pro-saved-sizing]:not(.hide)`).length > 0){
          item_variant = $(`[data-product-fitsmart-global] .profile_size`).text().trim();
        }
      }
    }

    product.item_name = line_item_attr.title;
    console.log("line_item_attr",line_item_attr);
    product.item_id = line_item_attr.sku ? line_item_attr.sku : "NA";
    product.price = parseInt(line_item_attr.price_min);
    product.item_brand = "Bombay Shirt Company";
    var variants = line_item_attr.variant_title ? line_item_attr.variant_title : "NA";
    var parts = variants.split("/");
    var variant = parts[1];
    product.item_variant = item_variant;
    product.item_category = line_item_attr.product_type;
    product.item_category2 = line_item_attr.occassion ? line_item_attr.occassion : 'NA';
    product.item_category3 = line_item_attr.pattern ? line_item_attr.pattern : 'NA';
    product.item_category4 = document.body.classList.contains("template-collection") ? $(`#collection-sort-popover .Popover__Value.is-selected`).text().trim() : 'NA';
    product.item_category5 = line_item_attr.colour ? line_item_attr.colour : 'NA';
    var orPrice = e.target.closest(".ProductItem").querySelector(".ProductItem__Info .ProductItem__Price.Price--compareAt") ? e.target.closest(".ProductItem").querySelector(".ProductItem__Info .ProductItem__Price.Price--compareAt").innerText.replace(",","") : null;
    console.log("orPrice",orPrice);
    if (orPrice != null) {
      var dis = orPrice - product.price;
    }
    product.discount = dis ? dis : 0;
    product.item_list_name = e.target.closest(".shopify-section").querySelector(".collTitle") ? e.target.closest(".shopify-section").querySelector(".collTitle").innerText : "NA";
    item_list_namep = product.item_list_name;
    product.item_list_id = e.target.closest(".shopify-section") ? e.target.closest(".shopify-section").id : "NA";
    item_list_idp = product.item_list_id;
    product.index = 1,
    product.quantity = 1;
    products.push(product);
    console.log(item_list_namep, "item_list_namep");
    console.log(item_list_idp, "item_list_idp");


    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: eventName,
      user_type_event: loggedin,
      User_ID_event: user_id,
      // item_list_name: $(".collTitle").text().trim(),
      item_list_name: item_list_namep ? item_list_namep : "NA",
      // item_list_id: $(".collection-page-main").closest(".shopify-section").attr("id").replace("shopify-section-template--",""),
      item_list_id: item_list_idp ? item_list_idp : "NA",
      PC1: pc1,
      PC2: pc2,
      ecommerce: {
        currency: "INR",
        items: products,
      },
    });
  }else{
    console.log("Document clicked else 1407", e);
    e.stopPropagation();
    var line_item = e.target.closest(".ProductItem").querySelector(".ProductItem__ImageWrapper");
    var line_item_attr = JSON.parse(line_item.dataset.product);

    var products = [];
    // Preparing the clicked product
    var product = {};
    product.item_name = line_item_attr.title;
    product.item_id = line_item_attr.variants.sku;
    product.price = parseInt(line_item_attr.price_min);
    product.item_brand = "Bombay Shirt Company";
    var variants = line_item_attr.variants.title ? line_item_attr.variants.title : "NA";
    var parts = variants.split("/");
    var variant = parts[1];
    product.item_variant = "NA";
    product.item_category = line_item_attr.product_type;
    product.item_category2 = line_item_attr.occassion ? line_item_attr.occassion : 'NA';
    product.item_category3 = line_item_attr.pattern ? line_item_attr.pattern : 'NA';
    product.item_category4 = document.body.classList.contains("template-collection") ? $(`#collection-sort-popover .Popover__Value.is-selected`).text().trim() : 'NA';
    product.item_category5 = line_item_attr.colour ? line_item_attr.colour : 'NA';
    var orPrice = e.target.closest(".ProductItem").querySelector(".ProductItem__Info .ProductItem__Price.Price--compareAt span")? e.target.closest(".ProductItem").querySelector(".ProductItem__Info .ProductItem__Price.Price--compareAt span").innerText.replace(",","") : null;
    if (parseInt(orPrice) > 0) {
      var dis = parseInt(orPrice) - product.price;
    }
    product.discount = dis ? dis : 0;
    let handle = line_item_attr.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    createCookie(`item_list_name${handle}`,readCookie("item_list_name"));
    createCookie(`item_list_id${handle}`,readCookie("item_list_id"));
    product.item_list_name = e.target.closest(".shopify-section").querySelector(".SectionHeader__Heading") ? e.target.closest(".shopify-section").querySelector(".SectionHeader__Heading").innerText : "NA";
    product.item_list_id = e.target.closest(".shopify-section") ? e.target.closest(".shopify-section").id : "NA";
    product.index = 1,
    product.quantity = 1;
    products.push(product);

    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: eventName,
      user_type_event: loggedin,
      User_ID_event: user_id,
      // item_list_name: readCookie("item_list_name"),
      // item_list_id: readCookie("item_list_id"),
      item_list_id: product.item_list_id ? product.item_list_id : "NA",
      item_list_name: product.item_list_name ? product.item_list_name : "NA",
      PC1: pc1,
      PC2: pc2,
      ecommerce: {
        currency: "INR",
        items: products,
      },
    });
  }
});

$(document).on("click", ".swymcs-wishlistplus-item-remove", function (e) {

  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "remove_from_wishlist_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    item_list_name: "My Wishlist",
    item_list_id: "NA",
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      currency: "INR",
      items: [{
        item_name: $(this).closest(".swymcs-wishlistplus-item").find(".swymcs-wishlistplus-item-title").text().trim(),
        item_id: $(this).closest(".swymcs-wishlistplus-item").attr("data-empi"),
        item_brand: "BSC",
        item_category: "NA",
        item_category2: "NA",
        item_category3: "NA",
        item_category4: "NA",
        item_category5: "NA",
        price: parseInt($(this).closest(".swymcs-wishlistplus-item").find(".swymcs-product-final-price").text().trim().replace("₹","")),
        discount: 0,
        item_list_name: "My Wishlist",
        item_list_id: "NA",
        item_variant: "NA",
        index: $(this).closest(".swymcs-wishlistplus-item").index() + 1,
        quantity: 1,
      }],
    },
  });

});

//14.view_item
var pdp_page = $("body").hasClass("template-product");
var search_page = $("body").hasClass("template-search");
console.log(search_page,"search_pagesearch_page");
if (pdp_page) {
  $(document).ready(function () {
    // For Details PDP page
    if (window.productInfo) {
      var discount = 0;
      if(window.productCMP != "" && window.productCMP != null){
        let cmp = window.productCMP / 100;
        // console.log("cmp",cmp, productInfo.product_price);
        discount = cmp - parseFloat(productInfo.product_price);
      }
      // console.log("discount>>>",discount);
      let handle = productInfo.product_title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

      console.log(handle,"handlehandle");
      localStorage.setItem(`ga_${handle}`,handle);
      console.log(localStorage.getItem(`ga_${handle}`),"localStorage.getItem(ga_)");
      // let item_list_nameSEACRH;
      // var item_list_sname = "Search Page";
      // item_list_nameSEACRH = item_list_sname;

      // var item_list_idSEACRH = localStorage.getItem("item_list_idSEACRH");

      let pincode = parseInt(localStorage.getItem("popupPinVal")) || 'NA';
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "view_item_ce",
        user_type_event: loggedin,
        User_ID_event: user_id,
        PC1: pc1,
        PC2: pc2,
        ecommerce: {
          currency: "INR",
          value: parseInt(productInfo.product_price),
          items: [
            {
              item_name: productInfo.product_title,
              item_id: productInfo.variants.sku,
              item_brand: productInfo.product_vendor,
              item_category: window.productInfo.product_type,
              item_category2: window.productInfo.occassion,
              item_category3: window.productInfo.pattern,
              item_category4: "NA",
              item_category5: window.productInfo.colour,
              price: parseInt(productInfo.product_price),
              discount: discount,
              item_list_name: localStorage.getItem(`ga_${handle}`) ? localStorage.getItem(`ga_${handle}`) : "NA",
              item_list_id: "NA",
              // item_list_name: item_list_nameSEACRH ? item_list_nameSEACRH : "NA",
              // item_list_id: item_list_idSEACRH ? item_list_idSEACRH : "NA",
              item_variant: "NA",
              index: 1,
              quantity: 1
            },
          ],
        },
      });
    }else if(document.body.classList.contains(`template-giftcard`)){
      // for GIFT CARD
      var price = parseInt(document.querySelector(`.gift-product-template .ProductMeta__PriceList .money`).innerText.replace("₹","").replace(",",""));
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "view_item_ce",
        user_type_event: loggedin,
        User_ID_event: user_id,
        PC1: pc1,
        PC2: pc2,
        ecommerce: {
          currency: "INR",
          value: price,
          items: [
            {
              item_name: "Gift Card",
              item_id: "Gift Card",
              item_brand: "Bombay Shirt Company",
              item_category: "Gift Card",
              item_category2: "NA",
              item_category3: "NA",
              item_category4: "NA",
              item_category5: "NA",
              price: price,
              discount: 0,
              item_list_name: "NA",
              item_list_id: "NA",
              item_variant: "NA",
              index: 1,
              quantity: 1
            },
          ],
        },
      });
    }
    // console.log(dataLayer);
  });
}
if (search_page) {
  $(document).ready(function () {
    // For Details PDP page
    if (window.productInfo) {
      var discount = 0;
      if(window.productCMP != "" && window.productCMP != null){
        let cmp = window.productCMP / 100;
        // console.log("cmp",cmp, productInfo.product_price);
        discount = cmp - parseFloat(productInfo.product_price);
      }
      // console.log("discount>>>",discount);
      let handle = productInfo.product_title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

      console.log(handle,"handlehandle");
      localStorage.setItem(`ga_${handle}`,handle);
      console.log(localStorage.getItem(`ga_${handle}`),"localStorage.getItem(ga_)");
      let item_list_nameSEACRH;
      var item_list_sname = "Search Page";
      item_list_nameSEACRH = item_list_sname;

      var item_list_idSEACRH = localStorage.getItem("item_list_idSEACRH");

      let pincode = parseInt(localStorage.getItem("popupPinVal")) || 'NA';
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "view_item_ce",
        user_type_event: loggedin,
        User_ID_event: user_id,
        PC1: pc1,
        PC2: pc2,
        ecommerce: {
          currency: "INR",
          value: parseInt(productInfo.product_price),
          items: [
            {
              item_name: productInfo.product_title,
              item_id: productInfo.variants.sku,
              item_brand: productInfo.product_vendor,
              item_category: window.productInfo.product_type,
              item_category2: window.productInfo.occassion,
              item_category3: window.productInfo.pattern,
              item_category4: "NA",
              item_category5: window.productInfo.colour,
              price: parseInt(productInfo.product_price),
              discount: discount,
              // item_list_name: localStorage.getItem(`ga_${handle}`) ? localStorage.getItem(`ga_${handle}`) : "NA",
              // item_list_id: "NA",
              item_list_name: item_list_nameSEACRH ? item_list_nameSEACRH : "NA",
              item_list_id: item_list_idSEACRH ? item_list_idSEACRH : "NA",
              item_variant: "NA",
              index: 1,
              quantity: 1
            },
          ],
        },
      });
    }
  });
}

// 15.add_to_cart
$(document).on("click",".ProductForm__AddToCart", function () {
    // For Details PDP page
    if (window.productInfo) {
      var discount = 0;
      if(window.productCMP != "" && window.productCMP != null){
        let cmp = window.productCMP / 100;
        // console.log("cmp",cmp, productInfo.product_price);
        discount = cmp - parseFloat(productInfo.product_price);
      }
      
      let handle = productInfo.product_title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      
      let item_variant = "NA";
      if($(this).closest(".ProductForm.rtw").length > 0){
        item_variant = $(this).closest(".ProductForm.rtw").find(`.SizeSwatchList [name="properties[_size]"]:checked`).val();
      }else{
        if($(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide)`).length > 0){
          if($(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide) input:checked`).val()){
            item_variant = $(this).closest(".ProductForm").find(`[data-pro-standard-size-main]:not(.hide) input:checked`).val();
          }
        }else{
          if($(this).closest(".ProductForm").find(`[data-pro-saved-sizing]:not(.hide)`).length > 0){
            item_variant = $(`[data-product-fitsmart-global] .profile_size`).text().trim();
          }
        }
      }

      let pincode = parseInt(localStorage.getItem("popupPinVal")) || 'NA';
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "add_to_cart_ce",
        user_type_event: loggedin,
        User_ID_event: user_id,
        PC1: pc1,
        PC2: pc2,
        ecommerce: {
          currency: "INR",
          value: parseInt(productInfo.product_price),
          items: [
            {
              item_name: productInfo.product_title,
              item_id: productInfo.variants.sku,
              item_brand: productInfo.product_vendor,
              item_category: window.productInfo.product_type,
              item_category2: window.productInfo.occassion,
              item_category3: window.productInfo.pattern,
              item_category4: "NA",
              item_category5: window.productInfo.colour,
              price: parseInt(productInfo.product_price),
              discount: discount,
              item_list_name: localStorage.getItem(`ga_${handle}`) ? localStorage.getItem(`ga_${handle}`) : "NA",
              item_list_id: "NA",
              item_variant: item_variant,
              index: 1,
              quantity: 1
            },
          ],
        },
      });
    }else if(document.body.classList.contains(`template-giftcard`)){
      // for GIFT CARD
      var price = parseInt(document.querySelector(`.gift-product-template .ProductMeta__PriceList .money`).innerText.replace("₹","").replace(",",""));
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "add_to_cart_ce",
        user_type_event: loggedin,
        User_ID_event: user_id,
        PC1: pc1,
        PC2: pc2,
        ecommerce: {
          currency: "INR",
          value: price,
          items: [
            {
              item_name: "Gift Card",
              item_id: "Gift Card",
              item_brand: "Bombay Shirt Company",
              item_category: "Gift Card",
              item_category2: "NA",
              item_category3: "NA",
              item_category4: "NA",
              item_category5: "NA",
              price: price,
              discount: "NA",
              item_list_name: "NA",
              item_list_id: "NA",
              item_variant: "NA",
              index: 1,
              quantity: 1
            },
          ],
        },
      });

    }else if(document.querySelector(`[data-product-quickview-main] form.ProductForm`)){
      // for COLL PAGE
      var currencyCode = "INR";
      var productName = document.querySelector(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).innerText;
      var productId = document.querySelector(`[data-product-quickview-main] .product_sku_id`).innerText;
      var price = parseInt(document.querySelector(`[data-product-quickview-main] .Product__Info .price-ship-main .Price:not(.Price--compareAt)`).innerText.replace("₹","").replace(",",""));
      var brand = "Bombay Shirt Company";
      var category = document.querySelector(`[data-product-quickview-main] [data-product-fitsmart-attributes-ele]`).dataset.type;
      var color = "NA";
      var variant = document.querySelector(`[data-product-quickview-main] form.ProductForm [name="id"]`).value;
      var discount = 0;
      if(document.querySelector(`[data-product-quickview-main] .Product__Info .price-ship-main .Price.Price--compareAt`)){
        let cmp = parseInt(document.querySelector(`[data-product-quickview-main] .Product__Info .price-ship-main .Price.Price--compareAt`).innerText.replace("₹","").replace(",",""));
        // console.log("cmp",cmp, productInfo.product_price);
        discount = cmp - price;
      }
      
      createCookie("variant", variant);
      let urlArr = document.querySelector(`[data-product-quickview-main] .pro-quickview-view-details`).href.split("/");
      let handle = urlArr[urlArr.length - 1];
      let item_list_name = document.querySelector(".collInfo .collTitle") ? document.querySelector(".collInfo .collTitle").innerText : `All ${category}`;
      let item_list_id = $(`.collection-section-main`).attr("data-section-id");


      let proObj = JSON.parse(document.querySelector(`.ProductItem__ImageWrapper[data-product-id="${document.querySelector(`.product-quickview-main .Product__Info .pro-quickview-view-details`).dataset.productId}"]`).dataset.product);
      let item_variant = "NA";
      if(document.querySelector(`[data-product-quickview-main] .ProductForm.rtw`)){
        item_variant = document.querySelector(`.product-quickview-main .Product__Info .SizeSwatchList input[name="properties[_size]"]:checked`).value;
      }else{
        item_variant = document.querySelector(`.product-quickview-main .Product__Info [data-pro-standard-size-main] input:checked`) != null ? document.querySelector(`.product-quickview-main .Product__Info [data-pro-standard-size-main] input:checked`).value : document.querySelector(`[data-product-fitsmart-global] .ProductSize__ShirtSize input:checked`).value;
      }
      dataLayer.push({ ecommerce: null });
      dataLayer.push({
        event: "add_to_cart_ce",
        user_type_event: loggedin,
        User_ID_event: user_id,
        PC1: pc1,
        PC2: pc2,
        ecommerce: {
          currency: "INR",
          value: price,
          items: [
            {
              item_name: productName,
              item_id: productId,
              item_brand: brand,
              item_category: category,
              item_category2: proObj.occassion ? proObj.occassion : 'NA',
              item_category3: proObj.pattern ? proObj.pattern : 'NA',
              item_category4: document.body.classList.contains("template-collection") ? $(`#collection-sort-popover .Popover__Value.is-selected`).text().trim() : 'NA',
              item_category5: proObj.colour ? proObj.colour : 'NA',
              price: price,
              discount: discount,
              item_list_name: item_list_name,
              item_list_id: item_list_id,
              item_variant: item_variant,
              index: 1,
              quantity: 1
            },
          ],
        },
      });

    }
    console.log(dataLayer);
  });

//16.remove_from_cart
$(document).on("click", ".Cart__ItemList .CartItem__Remove", function (e) {

  let cItem = $(this).parents(".CartItem")[0];
  cItemData = JSON.parse($(this).parents(".CartItem").attr("cart-data"));
  let handle = cItem.querySelector(`.CartItem__Title`).dataset.cartitemTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

  dataLayer.push({ ecommerce: null });
  dataLayer.push({
    event: "remove_from_cart_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      currency: "INR",
      value: cItemData.price_min.replace(",",""),
      items: [
        {
          item_name: cItemData.title,
          item_id: cItemData.sku,
          item_brand: "Bombay Shirt Company",
          item_category: cItemData.product_type,
          item_category2: cItemData.occassion,
          item_category3: cItemData.pattern,
          item_category4: "NA",
          item_category5: cItemData.colour,
          price: cItemData.price_min.replace(",",""),
          discount: cItemData.discount == "NA" ? 0 : parseFloat(cItemData.discount.replace(",","")),
          item_variant: cItem.querySelector(".CartItem__Variant").innerText.replace("Standard:","").replace("Custom:","").replace(cItemData.colour,"").replace("|","").trim(),
          quantity: 1,
          shipping_date: "NA",
          index: $(this).parents(".CartItem").index() - $(".CartItem.discount-alert,.CartItem.head-block").length + 1,
          item_list_name: localStorage.getItem(`ga_${handle}`) ? localStorage.getItem(`ga_${handle}`) : "NA",
          item_list_id: $(`.section-cart-template`).attr("id").replace("shopify-section-template--","")

        },
      ],
    },
  });
  let prods = generateItems();
  // console.log(dataLayer);
});

function loadCartGtm() {
  console.log("loadCartGtm");
  return $.ajax({
    url: "/cart.json",
    dataType: "json",
    async: false,
  }).done(function (result) {
    return result;
  });
}


function generateItems() {
  let prods = [];
  document.querySelectorAll(`.CartItem:not(.head-block,.discount-alert)`).forEach((cItem,index) => {
    // console.log("cItem>>>>>>>>>>>",cItem);
    cItemData = JSON.parse(cItem.getAttribute("cart-data"));
    let handle = cItem.querySelector(`.CartItem__Title`).dataset.cartitemTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

    let iVariant = cItem.querySelector(".CartItem__Variant").innerText.replace("Standard:","").replace("Custom:","").replace(cItemData.colour,"").replace("|","").trim();
    if(cItemData.template == "RTW"){
      iVariant = cItem.querySelector(".CartItem__Variant").innerHTML.split(`<span class="separator">|</span>`)[1].replace("Standard:","").replace("Custom:","").trim();
    }
    let cProd = {
      item_name: cItemData.title,
      item_id: cItemData.sku,
      item_brand: "Bombay Shirt Company",
      item_category: cItemData.product_type,
      item_category2: cItemData.occassion,
      item_category3: cItemData.pattern,
      item_category4: "NA",
      item_category5: cItemData.colour,
      price: parseFloat(cItemData.price_min.replace(",","")),
      discount: cItemData.discount == "NA" ? 0 : parseFloat(cItemData.discount.replace(",","")),
      // item_variant: cItem.querySelector(".CartItem__Variant").innerText.replace("Standard:","").replace("Custom:","").replace(cItemData.colour,"").replace("|","").trim(),
      item_variant: iVariant,
      quantity: 1,
      shipping_date: "NA",
      index: index + 1,
      item_list_name: localStorage.getItem(`ga_${handle}`) ? localStorage.getItem(`ga_${handle}`) : "NA",
      item_list_id: $(`.section-cart-template`).attr("id").replace("shopify-section-template--","")
    };
    prods.push(cProd);
  });

  setTimeout(() => {
    $.ajax({ url: '/cart/update.js', type: 'POST', data: { attributes: { 'GA_cart': JSON.stringify(prods) } }, dataType: "json", success: function(data) { }, error: function(error) { console.log("error",error) } });
  }, 1000);
  return prods;
}

//17.view_cart
var cartlen = $(".CartItem").length;
if (cartlen > 0) {
  // console.log("prods>>>>>>>>>>>>>>>",prods);
  let prods = generateItems();
  let objDL = {
    event: "view_cart_ce",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
    ecommerce: {
      currency: "INR",
      value: parseFloat($(`.order-summary-details .CartItem__Price`).text().replace("Total","").replace(":","").replace("₹","").replace(",","").trim()),
      items: prods,
    },
  };
  console.log("objDL",objDL);
  // localStorage.objDL = JSON.stringify(objDL);
  dataLayer.push({ ecommerce: null });
  dataLayer.push(objDL);
}

/* custom events */

//1.logo_click
$(document).on("click", ".main-logo,.menu-logo", function () {
  dataLayer.push({
    event: "logo_click",
    page_type: document.body.dataset.page,
    link_path: location.origin,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//2.navigation_menu_click
$(document).on("click", "[data-navigation_menu_click]", function () {
  dataLayer.push({
    event: "navigation_menu_click",
    page_type: document.body.dataset.page,
    cta_text: $(this).attr("data-navigation_menu_click"),
    link_path: $(this).attr("href") ? location.origin + $(this).attr("href") : "NA",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//3.hamburger_menu_interaction
$(document).on("click", "[data-hamburger_menu_interaction]", function () {
  dataLayer.push({
    event: "hamburger_menu_interaction",
    page_type: document.body.dataset.page,
    cta_text: $(this).attr("data-hamburger_menu_interaction"),
    link_path: $(this).attr("href") ? location.origin + $(this).attr("href") : "NA",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//4.footer_click
$(document).on("click", "[data-footer_click]", function () {
  dataLayer.push({
    event: "footer_click",
    page_type: document.body.dataset.page,
    cta_text: $(this).attr("data-footer_click"),
    link_path: location.origin + $(this).attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//5.search_term_entered
$(document).on("keyup", `header [type="search"]`,customDebounce(function(e){
  // console.log("changed>>>>>>>>>",this,$(this),e);
  if(e.which == 13){
    dataLayer.push({
      event: "search_term_entered",
      page_type: document.body.dataset.page,
      selection_type: "manual",
      search_term: e.target.value.trim(),
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }
},300));
$(document).on("click", ".input-search-icon", function () {
  dataLayer.push({
    event: "search_term_entered",
      page_type: document.body.dataset.page,
      selection_type: "manual",
      search_term: $(this).parents(".st-search-bar").find(`[name="st"]`).val(),
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
  });
});
$(document).on("click", ".st-trending-label", function (e) {
  e.preventDefault();
  dataLayer.push({
    event: "search_term_entered",
      page_type: document.body.dataset.page,
      selection_type: "auto",
      search_term: $(this).parents(".st-search-bar").find(`[name="st"]`).val(),
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
  });
  // debugger;
});


//7.homepage_category_bar
$(document).on("click", "[data-index-top-categories] .cate", function () {
  dataLayer.push({
    event: "homepage_category_bar",
    page_type: document.body.dataset.page,
    cta_text: $(this).find("a").text().trim(),
    link_path: location.origin + $(this).find("a").attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//8.about_us_click
$(document).on("click", ".index_cstm_textblock .index-rich-link a", function () {
  dataLayer.push({
    event: "about_us_click",
    page_type: document.body.dataset.page,
    section_name: $(this).parents(".index_cstm_textblock").find(".inner_div h2").text().trim(),
    cta_text: $(this).text().trim(),
    sub_section_name: "NA",
    selection_type: "NA",
    link_path: `https://www.bombayshirts.com/pages/about-us`,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", ".aboutus-style-content_button a", function () {
  dataLayer.push({
    event: "about_us_click",
    page_type: document.body.dataset.page,
    section_name: $(this).parents(".aboutus_container").find(".aboutus-style_heading_media").text().trim(),
    cta_text: $(this).text().trim(),
    // sub_section_name: $(this).parents(".aboutus_container").find(".aboutus-style_heading_content").text().trim(),
    sub_section_name: "NA",
    selection_type: "NA",
    link_path: $(this).attr("href").includes(location.origin) ? $(this).attr("href") : location.origin + $(this).attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", ".tailoring-style-btn a", function () {
  dataLayer.push({
    event: "about_us_click",
    page_type: document.body.dataset.page,
    section_name: $(this).attr("data-section_name").trim(),
    cta_text: $(this).text().trim(),
    sub_section_name: $(this).attr("data-sub_section_name").trim(),
    selection_type: "NA",
    link_path: $(this).attr("href").includes(location.origin) ? $(this).attr("href") : location.origin + $(this).attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", ".fabrics-style_second_item", function () {
  dataLayer.push({
    event: "about_us_click",
    page_type: document.body.dataset.page,
    section_name: "Luxurious fabrics",
    // cta_text: $(this).find(".fabrics-style-heading").text().trim(),
    cta_text: "Discover our fabrics",
    sub_section_name: $(this).find(".fabrics-style-heading").text().trim(),
    selection_type: "NA",
    link_path: location.origin + $(this).attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", ".composition-wrapp a", function () {
  dataLayer.push({
    event: "about_us_click",
    page_type: document.body.dataset.page,
    section_name: "Luxurious fabrics",
    cta_text: "Discover our fabrics",
    sub_section_name: "Composition",
    selection_type: $(this).find("h3").text().trim(),
    link_path: $(this).attr("href").includes(location.origin) ? $(this).attr("href") : location.origin + $(this).attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

$(document).on("click", ".Weaves-page a", function () {
  dataLayer.push({
    event: "about_us_click",
    page_type: document.body.dataset.page,
    section_name: "Weaves",
    cta_text: $(this).find("h3").text().trim(),
    sub_section_name: $(this).find("p").text().trim(),
    selection_type: "NA",
    link_path: $(this).attr("href").includes(location.origin) ? $(this).attr("href") : location.origin + $(this).attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//9.toggle_view
let current_state = document.body.clientWidth >= 1008 ? $(`.CollectionToolbar .CollectionToolbar__LayoutType.is-active[data-grid-type="desktop"]`).attr("aria-label") : $(`.CollectionToolbar .CollectionToolbar__LayoutType.is-active[data-grid-type="mobile"]`).attr("aria-label");
$(document).on("click", "[data-toggle_view]", function () {
  dataLayer.push({
    event: "toggle_view",
    page_type: document.body.dataset.page,
    selection_type: "product_category",
    cta_text: $(this).attr("data-toggle_view"),
    current_state: current_state != undefined ? current_state : "NA",
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `[data-action="change-layout-mode"]`, function () {
  
  dataLayer.push({
    event: "toggle_view",
    page_type: document.body.dataset.page,
    selection_type: "product_listing_layout",
    cta_text: $(this).attr("aria-label"),
    current_state: current_state,
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
  current_state = $(this).attr("aria-label");
});

let current_stateS = "";
setTimeout( () => {
  current_stateS = document.body.clientWidth >= 1008 ? $(`.search-right-bar .hidden-phone .CollectionToolbar__LayoutType.is-active`).attr("aria-label") : $(`.search-right-bar .hidden-tablet-and-up .CollectionToolbar__LayoutType.is-active`).attr("aria-label");
},1500);
$(document).on("click", `.search-right-bar .CollectionToolbar__LayoutType`, function () {
  dataLayer.push({
    event: "toggle_view",
    page_type: document.body.dataset.page,
    selection_type: "product_listing_layout",
    current_state: current_stateS,
    cta_text: $(this).attr("aria-label"),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//10.color_interaction
$(document).on("click", `[data-color_interaction]`, function () {
  dataLayer.push({
    event: "color_interaction",
    page_type: document.body.dataset.page,
    color_name: $(this).attr("data-color_interaction"),
    product_name: $(this).attr("product_title"),
    link_path: location.origin + $(this).find("a").attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//11.edit_size_cta_click
$(document).on("click", `[data-show-shopped-with-us-popup-btn],[data-add-custom-size-btn]`, function () {
  dataLayer.push({
    event: "edit_size_cta_click",
    page_type: document.body.dataset.page,
    product_name: $(this).parents(`.Product__Info`).find(".ProductMeta__Title").text().trim(),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//12.default_size_interaction
$(document).on("click", `[data-pro-standard-size-main] input[type="radio"]`, function () {
  dataLayer.push({
    event: "default_size_interaction",
    page_type: document.body.dataset.page,
    product_name: $(this).parents(`.Product__Info`).find(".ProductMeta__Title").text().trim(),
    section_name: $(this).parents(`[data-pro-standard-size-main]`).find(".ProductElements__Name .text-wrap-span").text().trim(),
    cta_text: $(this).val(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
// rtw
$(document).on("change", `.ProductForm.rtw .ProductForm__Variants input`, function () {
  dataLayer.push({
    event: "default_size_interaction",
    page_type: document.body.dataset.page,
    product_name: $(this).parents(`.Product__Info`).find(".ProductMeta__Title").text().trim(),
    section_name: $(this).parents(`.rtw-mobile-slide`).find(".rtw-size-top p").text().trim(),
    cta_text: $(this).val(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `[data-pro-standard-size-main] [data-pro-fitsmart-guide]`, function () {
  dataLayer.push({
    event: "default_size_interaction",
    page_type: document.body.dataset.page,
    product_name: $(this).parents(`.Product__Info`).find(".ProductMeta__Title").text().trim(),
    section_name: $(this).parents(`[data-pro-standard-size-main]`).find(".ProductElements__Name .text-wrap-span").text().trim(),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
// rtw
$(document).on("click", `.ProductForm.rtw [data-pro-fitsmart-guide]`, function () {
  dataLayer.push({
    event: "default_size_interaction",
    page_type: document.body.dataset.page,
    product_name: $(this).parents(`.Product__Info`).find(".ProductMeta__Title").text().trim(),
    section_name: $(this).parents(`.rtw-mobile-slide`).find(".rtw-size-top p").text().trim(),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `.product-fitsmart-sizechart-item.standard-size-guide [data-pro-sizechart-tab-btn]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "default_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: $(this).parents(`.product-fitsmart-sizechart-item`).find(".product-fitsmart-popup-left").text().trim(),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("change", `.product-fitsmart-sizechart-item.standard-size-guide input.sizechart-inch-cm-checkbox`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  // console.log("aaaaaa",$(this).val(),$(this)[0],$(this)[0].checked)
  dataLayer.push({
    event: "default_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Size Guide",
    cta_text: $(this)[0].checked == true ? "cm" : "inch",
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `.product-fitsmart-sizechart-item.standard-size-guide [data-pro-measuring-tips-btn]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "default_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Measuring Tips",
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

$(document).on("click", `.product-fitsmart-sizechart-item.standard-size-guide .ButtonGroup__Item`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "default_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: $(this).parents(`.product-fitsmart-sizechart-item`).find(".product-fitsmart-popup-left").text().trim(),
    cta_text: $(this).find(".links-text p").text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//13.customize_cta_click
// $(document).on("click", `[data-customise-custom-btn],[data-save-customisations-btn],[data-discard-customisations-btn]`, function () {
$(document).on("click", `[data-customise-custom-btn]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "customize_cta_click",
    page_type: document.body.dataset.page,
    product_name: product_name,
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

const popup = document.querySelector("body.temp_bsc .sure-exit-customisation-popup");
if (popup) {
    popup.addEventListener("click", function(event) {
        if (event.target.closest('[data-save-customisations-btn], [data-discard-customisations-btn]')) {
            const button = event.target.closest('[data-save-customisations-btn], [data-discard-customisations-btn]');
            
            let product_name = "";
            if (document.body.classList.contains("template-product")) {
                const titleEl = document.querySelector("body.template-product #main .Product__Info .ProductMeta__Title");
                product_name = titleEl ? titleEl.textContent.trim() : "";
            } else if (document.body.classList.contains("template-collection")) {
                const titleEl = document.querySelector("[data-product-quickview-main] .Product__Info .ProductMeta__Title");
                product_name = titleEl ? titleEl.textContent.trim() : "";
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "customize_cta_click",
                page_type: document.body.dataset.page || "",
                product_name: product_name,
                cta_text: button.textContent.trim(),
                // link_path: location.href,
                user_type_event: loggedin,
                User_ID_event: user_id,
                PC1: pc1,
                PC2: pc2,
            });
        }
    });
}


$(document).on("click", `[data-pro-customise-alert-popup-close]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "customize_cta_click",
    page_type: document.body.dataset.page,
    product_name: product_name,
    cta_text: "Close",
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//14.custom_size_interaction
$(document).on("change", `[data-product-fitsmart-global] .ProductSize__Elements input[type="radio"]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: $(this).parents(".ProductSize__Elements").find(".ProductElements__Name").text().replace("Guide",""),
    cta_text: $(this).val(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `[data-product-fitsmart-global] [data-edit-fitsmart-popup-open]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: $(this).parents(".head").find("h3").text().trim(),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

$(document).on("click", `.product-fitsmart-sizechart-item:not(.standard-size-guide) [data-pro-sizechart-tab-btn]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: $(this).parents(`.product-fitsmart-sizechart-item`).find(".product-fitsmart-popup-left").text().trim(),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("change", `.product-fitsmart-sizechart-item:not(.standard-size-guide) input.sizechart-inch-cm-checkbox`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  // console.log("aaaaaa",$(this).val(),$(this)[0],$(this)[0].checked)
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Size Guide",
    cta_text: $(this)[0].checked == true ? "cm" : "inch",
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `.product-fitsmart-sizechart-item:not(.standard-size-guide) [data-pro-measuring-tips-btn]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Measuring Tips",
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

$(document).on("click", `[data-product-fitsmart-global] [data-pro-fitsmart-guide]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: $(this).parents(`.ProductElements__Name`).text().replace("Guide",""),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `[data-product-fitsmart-global] [data-calculate-fitsmart]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Add custom size",
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `[data-product-fitsmart-global] [data-save-changes-btn]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: $(this).parents(`.pro-fitsmart-drawer-wrap`).find(".product-edit-fitsmart-head-left span").text().trim(),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `[data-product-fitsmart-global] [data-edit-confirm-fitsmart-close],[data-product-fitsmart-global] [data-confirm-changes-btn]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: $(this).parents(`.pro-fitsmart-drawer-wrap`).find(".product-edit-fitsmart-head-left").text().trim(),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `[data-product-fitsmart-global] [data-switch-to-standard-confirm-btn]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Edit custom size",
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `[data-product-fitsmart-global] [data-reconfirm-switch-to-standard-cancel],[data-product-fitsmart-global] [data-switch-to-standard-btn]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Switch to standard size?",
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `.pro-fitsmart-drawer-body .ProductUnsure__About .ButtonGroup__Item`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  let cta = $(this).find(".links-text p").text().trim();
  if($(this).hasClass("call_")){
    cta = "call";
  }else if($(this).hasClass("chat_")){
    cta = "whatsapp";
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Edit custom size",
    cta_text: cta,
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

$(document).on("click", `[data-close-fitsmart-popup]`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "custom_size_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Edit custom size",
    cta_text: $(this).text().trim() != "" ? $(this).text().trim() : "Close",
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//15.image_cta_click
$(document).on("click", `.custom_meta_link.similar-product`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "image_cta_click",
    page_type: document.body.dataset.page,
    product_name: product_name,
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

$(document).on("click", `.Footer__Newsletter .Form__Submit`, function () {
  dataLayer.push({
    event: "form_field_interaction",
    page_type: document.body.dataset.page,
    form_type: "newsletter",
    section_name:"Subscribe to newsletter",
    selection_type:"Email",
    // cta_text: $(this).parents(".Footer__Newsletter").find('.Form__Input[type="email"]').val(),
    cta_text: "Subscribe",
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("blur", `.ProductForm.giftcard .recipient-fields .field__input`, function () {
  let item = this;
  if(item.value && item.value.trim() !== ""){
    dataLayer.push({
      event: "form_field_interaction",
      page_type: document.body.dataset.page,
      form_type: "gift_card",
      section_name: "Gift card",
      selection_type: item.getAttribute("placeholder"),
      cta_text: "Gift Card",
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }
});

$(document).on("blur", `.corp-form input.needsclick`, function () {
  let item = this;

  if(item.value && item.value.trim() !== ""){
    dataLayer.push({
      event: "form_field_interaction",
      page_type: document.body.dataset.page,
      form_type: "corporate_orders",
      section_name: "Corporate Orders",
      selection_type: item.getAttribute("placeholder"),
      cta_text: "NA",
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }
});

document.addEventListener("click", function(event) {
    // Check if the click happened inside .corp-form and on a button
    const button = event.target.closest(".corp-form button");
    if (button && button.textContent.trim().toLowerCase().includes("submit")) {
        
        dataLayer.push({
            event: "form_field_interaction",
            page_type: document.body.dataset.page,
            form_type: "corporate_orders",
            section_name: "Corporate Orders",
            selection_type: "NA",
            cta_text: button.textContent.trim(),
            user_type_event: loggedin,
            User_ID_event: user_id,
            PC1: pc1,
            PC2: pc2
        });

        console.log("DataLayer pushed for submit button click");
    }
});

$(document).on("click", `form#address_form_new button.Form__Submit`, function () {
  dataLayer.push({
    event: "form_field_interaction",
    page_type: document.body.dataset.page,
    form_type: "address",
    section_name:"Add new address",
    selection_type: "NA",
    cta_text: "Save New address",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("blur", `form#address_form_new input.Form__Input`, function () {
  let item = this;

  if(item.value && item.value.trim() !== ""){
    dataLayer.push({
      event: "form_field_interaction",
      page_type: document.body.dataset.page,
      form_type: "address",
      section_name: "Add new address",
      selection_type: item.getAttribute("aria-label"),
      cta_text: item.getAttribute("aria-label"),
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }
});

$(document).on("click", `.Modal.edit-add-model .Modal__Content form button.Form__Submit`, function () {
  dataLayer.push({
    event: "form_field_interaction",
    page_type: document.body.dataset.page,
    form_type: "address",
    section_name:"Edit address",
    selection_type: "NA",
    cta_text: "Save address",
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("blur", `.Modal.edit-add-model .Modal__Content form input.Form__Input`, function () {
  let item = this;

  if(item.value && item.value.trim() !== ""){
    dataLayer.push({
      event: "form_field_interaction",
      page_type: document.body.dataset.page,
      form_type: "address",
      section_name: "Edit address",
      selection_type: item.getAttribute("aria-label"),
      cta_text: item.getAttribute("aria-label"),
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }
});

//17.dropdown_interaction
$(document).on("click", `[data-pro-accordion-item] .pro-accordion-title`, function () {
  dataLayer.push({
    event: "dropdown_interaction",
    page_type: document.body.dataset.page,
    selection_type: $(this).parents("[data-pro-accordion-item]").hasClass("active") ? "collapse" : "expand", // reverse value
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `.Footer .Collapsible .Collapsible__Button`, function () {
  dataLayer.push({
    event: "dropdown_interaction",
    page_type: document.body.dataset.page,
    selection_type: $(this).attr("aria-expanded") == "false" ? "collapse" : "expand", // reverse value
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `.section-faq .Faq__Question`, function () {
  dataLayer.push({
    event: "dropdown_interaction",
    page_type: document.body.dataset.page,
    selection_type: $(this).hasClass("open-answer") ? "expand" : "collapse",
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//18.call_button_click
$(document).on("click", `[data-lead-gen-open]`, function () {
  dataLayer.push({
    event: "call_button_click",
    page_type: document.body.dataset.page,
    selection_type: "Connect",
    cta_text: "Lead generation",
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `.leadgen_main_popup .leadgen_popup_item`, function () {
  dataLayer.push({
    event: "call_button_click",
    page_type: document.body.dataset.page,
    selection_type: "Connect",
    cta_text: $(this).find("a").length > 0 ? $(this).find("a").eq(0).text().trim() : $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `.offer_block.need-assist-block [data-lead-gen-open-custom]`, function () {
  dataLayer.push({
    event: "call_button_click",
    page_type: document.body.dataset.page,
    selection_type: "Click here",
    cta_text: "Need assistance?",
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//19.filter_applied

let checkedValuesGLOBAL;
$(document).on("click", `[data-filters-button]`, function () {
  let checkedValues = Array.from(
    document.querySelectorAll(".filter-category_filters .filter-category_filter-item input:checked")
  ).map(input => (input.dataset.id + "-" + input.value)).join("|");
  console.log("checkedValues",checkedValues);
  if(checkedValues == "" || checkedValues == undefined){
    checkedValues = "NA";
  }
  checkedValuesGLOBAL = checkedValues;
  console.log("checkedValuesGLOBAL",checkedValuesGLOBAL,"checkedValues",checkedValues);
  dataLayer.push({
    event: "filter_applied",
    page_type: document.body.dataset.page,
    section_name: $(`.collTitle`).text().trim(),
    applied_value: checkedValues.replaceAll("pf_pt_","").replaceAll("pf_t_","").replaceAll("pf_p_","").replaceAll("pf_m_","").replaceAll("pf_opt_","").replaceAll("::custom::",""),
    cta_text: "Open",
    link_path: "NA",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `[data-collection-filters-close]`, function () {
  let checkedValues = Array.from(
    document.querySelectorAll(".filter-category_filters .filter-category_filter-item input:checked")
  ).map(input => (input.dataset.id + "-" + input.value)).join("|");
  if(checkedValues == "" || checkedValues == undefined){
    checkedValues = "NA";
  }
  dataLayer.push({
    event: "filter_applied",
    page_type: document.body.dataset.page,
    section_name: $(`.collTitle`).text().trim(),
    applied_value: checkedValuesGLOBAL.replaceAll("pf_pt_","").replaceAll("pf_t_","").replaceAll("pf_p_","").replaceAll("pf_m_","").replaceAll("pf_opt_","").replaceAll("::custom::",""),
    cta_text: "Close",
    link_path: "NA",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `[data-collection-filters-apply-btn],[data-collection-filters-clear-btn]`, function () {
  let checkedValues = Array.from(
    document.querySelectorAll(".filter-category_filters .filter-category_filter-item input:checked")
  ).map(input => (input.dataset.id + "-" + input.value)).join("|");
  if(checkedValues == "" || checkedValues == undefined || $(this).hasClass("clear-all")){
    checkedValues = "NA";
    checkedValuesGLOBAL = "NA";
  }
  dataLayer.push({
    event: "filter_applied",
    page_type: document.body.dataset.page,
    section_name: $(`.collTitle`).text().trim(),
    applied_value: checkedValues.replaceAll("pf_pt_","").replaceAll("pf_t_","").replaceAll("pf_p_","").replaceAll("pf_m_","").replaceAll("pf_opt_","").replaceAll("::custom::",""),
    cta_text: $(this).text().trim(),
    link_path: "NA",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//20.sort_applied
$(document).on("click", `[data-sort-item]`, function () {
  dataLayer.push({
    event: "sort_applied",
    page_type: document.body.dataset.page,
    section_name: $(`.collTitle`).text().trim(),
    applied_value: $(this).text().trim(),
    // cta_text: "Open",
    link_path: "NA",
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//21.login_initiate
$(document).on("click", `.send-btn.otp-btn`, function () {
  dataLayer.push({
    event: "login_initiate",
    page_type: document.body.dataset.page,
    selection_type: $(this).parents(".login-content-wrap").find(".input-box-content[data-current].active").attr("data-current"),
    cta_text: $(this).text().trim(),
    link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//22.otp_submit
$(document).on("click", `.verify-btn.otp-btn`, function () {
  dataLayer.push({
    event: "otp_submit",
    page_type: document.body.dataset.page,
    selection_type: $(this).parents(".login-content-wrap").find(".input-box-content[data-current].active").attr("data-current"),
    cta_text: $(this).text().trim(),
    link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//23.resend_otp
$(document).on("click", `.resend-btn`, function () {
  dataLayer.push({
    event: "resend_otp",
    page_type: document.body.dataset.page,
    selection_type: $(this).parents(".login-content-wrap").find(".input-box-content[data-current].active").attr("data-current"),
    cta_text: $(this).text().trim(),
    link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//24.login_success
$(document).on("click", `.other-options-wrap .other-option-inner`, function () {
  localStorage.loginType = $(this).attr("data-current");
});


document.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");
  // Your JavaScript code to interact with the DOM goes here
  if(document.body.classList.contains("notlogged")){
    localStorage.loginSuccessAllow = true;
  }else{
    if(localStorage.loginSuccessAllow == "true"){
      setTimeout(() => {
        localStorage.loginSuccessAllow = false;
        dataLayer.push({
          event: "login_success",
          page_type: document.body.dataset.page,
          selection_type: localStorage.loginType != undefined ? localStorage.loginType : "mobile",
          // cta_text: $(this).text().trim(),
          link_path: location.href,
          user_type_event: loggedin,
          User_ID_event: user_id,
          PC1: pc1,
          PC2: pc2,
        });
      }, 2000);
    }
  }
});



//25.profile_section_interaction
$(document).on("click", `.profile-popup-main .list-main a`, function () {
  dataLayer.push({
    event: "profile_section_interaction",
    page_type: document.body.dataset.page,
    cta_text: $(this).text().trim(),
    link_path: location.origin + $(this).attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//26.style_customisation
let checkedValuesDefaults;
let checkedValuesDefaultsMONO;
$(document).on("click", `.customise-btn .common-btn-edit`, function () {
  setTimeout(() => {
    checkedValuesDefaults = Array.from(
      $(`.customise-popup.customise-editor:not(.hide)`)[0]?.querySelectorAll(".Grid__Cell.active")
    ).map(input => (input.closest(".tab-pane").id + "-" + input.querySelector("[data-imagevalue]")?.dataset.alt)).join("|");
    if(checkedValuesDefaults == "" || checkedValuesDefaults == undefined){
      checkedValuesDefaults = "NA";
    }

    if($("#personalise.tab-pane.active").length > 0){
      checkedValuesDefaultsMONO = $(`.customise-popup.customise-editor:not(.hide) .style-row .active`).text().trim() != "" ? `Font Style(${$(`.customise-popup.customise-editor:not(.hide) .style-row .active`).text().trim()})` : "Font Style(NA)";
      checkedValuesDefaultsMONO += "|Thread Color(#" + $(`.customise-popup.customise-editor:not(.hide) .thread-color .color-list-outer-box.active`).attr("data-color") + ")";
    }

    console.log("checkedValuesDefaults",checkedValuesDefaults);
  },2000);
});

$(document).ready(function() {
$(document).on("click", `.common-btn.apply,.common-btn.cancle`, function () {
  console.log("checkedValuesDefaults",checkedValuesDefaults);
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  let sectionName = $(this).parents(".customise-popup").attr("data-custom").replace("-btn","");

  if(sectionName == "personalise-collar"){
    sectionName = $(this).parents(".customise-popup").find(".tab-pane.personalise-placement-tab .Grid__Cell.active .icon[data-alt]").attr("data-alt").replace("Placement","").trim();
    //field_name
    let checkedValues = "";
    checkedValues = $(this).parents(".customise-popup").find(".style-row .active").text().trim() != "" ? `Font Style(${$(this).parents(".customise-popup").find(".style-row .active").text().trim()})` : "Font Style(NA)";
    checkedValues += "|#Thread Color(" + $(this).parents(".customise-popup").find(".thread-color .color-list-outer-box.active").attr("data-color") + ")";
    // console.log("sectionName",sectionName,"checkedValues",checkedValues,"product_name",product_name);

    if($(this).hasClass("cancle")){
      checkedValues = checkedValuesDefaultsMONO;
    }
    dataLayer.push({
      event: "monogram_customisation",
      page_type: document.body.dataset.page,
      product_name: product_name,
      section_name: sectionName,
      selection_type: checkedValues,
      field_name: $(this).parents(".customise-popup").find(".enter-initial-input.Form__Input").val(),
      cta_text: $(this).text().trim(),
      // link_path: location.href,
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });

  }else if(sectionName == "contrast-collar" || sectionName == "contrast-placket" || sectionName == "contrast-cuff" || sectionName == "elbow-patch" || sectionName == "gusset"){
    let checkedValues = Array.from(
      $(this).parents(".customise-popup")[0]?.querySelectorAll(".content-box-wrapper .Grid__Cell.active")
    ).map(input => (input.closest(".tab-pane").id + "-" + input.querySelector("[data-imagevalue]")?.dataset.alt)).join("|");
    if(checkedValues == "" || checkedValues == undefined){
      checkedValues = "NA";
    }
    let checkedFabrics = Array.from(
      $(this).parents(".customise-popup")[0]?.querySelectorAll(".contrast-fabrics-list .Grid__Cell.active")
    ).map(input => input.querySelector("[data-alt]").dataset.alt.trim()).join("|");
    if(checkedFabrics == "" || checkedFabrics == undefined){
      checkedFabrics = "NA";
    }
    if($(this).hasClass("cancle")){
      checkedValues = checkedValuesDefaults
    }
    // console.log("sectionName",sectionName,"checkedValues",checkedValues,"checkedFabrics",checkedFabrics,"product_name",product_name);
    dataLayer.push({
      event: "contrast_customisation",
      page_type: document.body.dataset.page,
      product_name: product_name,
      section_name: sectionName,
      selection_type: checkedValues,
      applied_value: checkedFabrics,
      cta_text: $(this).text().trim(),
      // link_path: location.href,
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }else{
    let checkedValues = Array.from(
      $(this).parents(".customise-popup")[0].querySelectorAll(".Grid__Cell.active")
    ).map(input => (input.closest(".tab-pane").id + "-" + input.querySelector("[data-imagevalue]")?.dataset.alt)).join("|");

    if(checkedValues == "" || checkedValues == undefined){
      checkedValues = "NA";
    }
    if($(this).hasClass("cancle")){
      checkedValues = checkedValuesDefaults
    }
    // console.log("sectionName",sectionName,"checkedValues",checkedValues,"product_name",product_name);
    dataLayer.push({
      event: "style_customisation",
      page_type: document.body.dataset.page,
      product_name: product_name,
      section_name: sectionName.replace("thread","buttons"),
      selection_type: checkedValues.replaceAll("collar-",""),
      cta_text: $(this).text().trim(),
      // link_path: location.href,
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }
});
});

//27.customization_interaction
$(document).on("change", `.new_customize .ProductSize__Elements input`, function () {
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  let sectionName = $(this).attr("name").replace("properties[_","").replace("?]","");
  dataLayer.push({
    event: "customization_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Customise",
    selection_type: sectionName,
    cta_text: $(this).val(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", `.customise-box [data-pro-customise-popup-close-btn], body.exit-customisation-alert [data-pro-customise-alert-popup-close]`, function () {
  // console.log("close GTM event");
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "customization_interaction",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: document.body.classList.contains("exit-customisation-alert") ? $(`.sure-exit-customisation-popup .Heading`).text().trim() : "Customise",
    selection_type: "NA",
    cta_text: "Close",
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
const popup2 = document.querySelector("body:not(.temp_bsc) .sure-exit-customisation-popup");
if (popup2) {
    popup2.addEventListener("click", function(event) {
        if (event.target.closest('[data-save-customisations-btn], [data-discard-customisations-btn]')) {
            const button = event.target.closest('[data-save-customisations-btn], [data-discard-customisations-btn]');
            
            let product_name = "";
            if (document.body.classList.contains("template-product")) {
                const titleEl = document.querySelector("body.template-product #main .Product__Info .ProductMeta__Title");
                product_name = titleEl ? titleEl.textContent.trim() : "";
            } else if (document.body.classList.contains("template-collection")) {
                const titleEl = document.querySelector("[data-product-quickview-main] .Product__Info .ProductMeta__Title");
                product_name = titleEl ? titleEl.textContent.trim() : "";
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "customization_interaction",
                page_type: document.body.dataset.page,
                product_name: product_name,
                section_name: $(`.sure-exit-customisation-popup .Heading`).text().trim(),
                selection_type: "NA",
                cta_text: button.textContent.trim(),
                user_type_event: loggedin,
                User_ID_event: user_id,
                PC1: pc1,
                PC2: pc2,
            });
        }
    });
}


//30.back_to_top_click
$(document).on("click", `#scrollTop`, function () {
  dataLayer.push({
    event: "back_to_top_click",
    page_type: document.body.dataset.page,
    // cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//31.scroll
let lastPercentNumber = 0;
let allowToTrigger = true;
let allowFor25 = true;
let allowFor50 = true;
let allowFor75 = true;
let allowFor100 = true;
window.addEventListener("scroll",function(e){
  let docHeight = document.body.clientHeight - 500;
  let percentNumber = docHeight / window.scrollY;
  // console.log("percentNumber",percentNumber);
  if(lastPercentNumber != percentNumber){
    allowToTrigger = true;
  }
  if(percentNumber <= 1 && allowFor100){
    allowFor100 = false;
    dataLayer.push({
      event: "scroll",
      page_type: document.body.dataset.page,
      percent_scrolled: 100,
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }else if(percentNumber > 1 && percentNumber <= 2 && allowFor75){
    allowFor75 = false;
    dataLayer.push({
      event: "scroll",
      page_type: document.body.dataset.page,
      percent_scrolled: 75,
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }else if(percentNumber > 2 && percentNumber <= 3 && allowFor50){
    allowFor50 = false;
    dataLayer.push({
      event: "scroll",
      page_type: document.body.dataset.page,
      percent_scrolled: 50,
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }else if(percentNumber > 3 && percentNumber <= 4 && allowFor25){
    allowFor25 = false;
    dataLayer.push({
      event: "scroll",
      page_type: document.body.dataset.page,
      percent_scrolled: 25,
      user_type_event: loggedin,
      User_ID_event: user_id,
      PC1: pc1,
      PC2: pc2,
    });
  }
});

//32.arrow_click
if(document.body.clientWidth >= 1008){
$(document).on("pointerdown", ".pswp__button.pswp__button--prev,.pswp__button.pswp__button--next,.pswp__button.pswp__button--close", function () {
  console.log("btn clicked",$(this));

  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "arrow_click",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Image Gallery",
    selection_type: $(this).attr("title"),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
}else{
$(document).on("click touchend", ".pswp__button.pswp__button--prev,.pswp__button.pswp__button--next,.pswp__button.pswp__button--close", function () {
  console.log("btn clicked",$(this));

  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "arrow_click",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Image Gallery",
    selection_type: $(this).attr("title"),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
}
$(document.body).on("pointerdown", ".featured-collections .flickity-prev-next-button", function() {
// $(document).click(function (event) {
  // console.log("btn clicked",$(this));
  let product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  if(document.body.classList.contains("template-collection")){
    product_name = $(`[data-product-quickview-main] .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "arrow_click",
    page_type: document.body.dataset.page,
    product_name: "NA",
    section_name: $(this).parents(".featured_collections").find(".SectionHeader__Heading").text().trim(),
    selection_type: $(this).attr("aria-label"),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//34.address_interaction
$(document.body).on("click", ".Button.new_address, .Segment__ActionItem.edit_address, .Segment__ActionItem.delete_address", function () {
  dataLayer.push({
    event: "address_interaction",
    page_type: document.body.dataset.page,
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//35.cta_click
$(document).on("click", ".leadgen_main_popup .whatsapp_btn,.leadgen_main_popup .tel_btn,.pdp_multicolumn_button_block .Button", function () {
  let product_name = "NA";
  if(document.body.classList.contains("template-product")){
    product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "cta_click",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: "Lead generation",
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", ".featured-collections .SectionHeader a.Link,.featured-collections .ins-ups-tabs a.Link", function () {
  let product_name = "NA";
  if(document.body.classList.contains("template-product")){
    product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
  }
  dataLayer.push({
    event: "cta_click",
    page_type: document.body.dataset.page,
    product_name: product_name,
    section_name: $(this).parents(".featured_collections").find(".SectionHeader .SectionHeader__Heading").text().trim().replace($(this).parents(".featured_collections").find(".SectionHeader .SectionHeader__Heading .pro-count").text().trim(),""),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});


//36.blog_click
$(document).on("click", ".Footer_Tabs .Collapsible__Content a", function () {
  if($(this).attr("href").includes("blogs")){
  dataLayer.push({
    event: "blog_click",
    page_type: document.body.dataset.page,
    section_name: "Blogs",
    blog_name: $(this).text().trim(),
    cta_text: $(this).text().trim(),
    link_path: $(this).attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
  }
});
$(document).on("click", ".ArticleNav .Grid__Cell .ArticleItem", function () {
  dataLayer.push({
    event: "blog_click",
    page_type: document.body.dataset.page,
    section_name: "Suggested Blogs",
    blog_name: $(".Article .Article__Title").text().trim(),
    cta_text: $(this).parents(".Grid__Cell").find(".ArticleItem__Title").text().trim(),
    link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});
$(document).on("click", ".Article__Content a", function () {
  dataLayer.push({
    event: "blog_click",
    page_type: document.body.dataset.page,
    section_name: $(this).parents(".Article__Content").find(".Article__Title").text().trim(),
    blog_name: $(this).parents(".Article__Content").find(".Article__Title").text().trim(),
    cta_text: $(this).text().trim(),
    link_path: $(this).attr("href"),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//37.collection_menu_click
$(document).on("click", "[data-collection_menu_click]", function () {
  dataLayer.push({
    event: "collection_menu_click",
    page_type: document.body.dataset.page,
    section_name: $(".collTitle").text().trim(),
    cta_text: $(this).attr("data-collection_menu_click"),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});


//38.view_customization_click
$(document).on("click", ".customized-details a", function () {
  // if($(this).text().trim() == "View Customisations"){
  dataLayer.push({
    event: "view_customization_click",
    page_type: document.body.dataset.page,
    product_name: $(this).parents(".CartItem").find(".CartItem__Title").text().trim(),
    cta_text: $(this).text().trim(),
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
  // }
});

//39.pincode_interaction
let currentPincode = localStorage.customerPincode;
$(document).on("click", ".find-store-section .btn_name", function () {
  setTimeout(() => {
    if(localStorage.customerPincode != currentPincode){
      currentPincode = localStorage.customerPincode;
      dataLayer.push({
        event: "pincode_interaction",
        page_type: document.body.dataset.page,
        section_name: $(this).closest(".find-store-innder").find(".content-header h5").text().trim(),
        cta_text: $(this).text().trim(),
        // link_path: location.href,
        user_type_event: loggedin,
        User_ID_event: user_id,
        PC1: pc1,
        PC2: pc2,
      });
    }
  }, 1500);
});
$(document).on("click", ".pin-input-wrapp .search_icon-submit", function () {
  setTimeout(() => {
    if(localStorage.customerPincode != currentPincode){
      currentPincode = localStorage.customerPincode;
      dataLayer.push({
        event: "pincode_interaction",
        page_type: document.body.dataset.page,
        section_name: "Our Stores",
        cta_text: "Submit",
        // link_path: location.href,
        user_type_event: loggedin,
        User_ID_event: user_id,
        PC1: pc1,
        PC2: pc2,
      });
    }
  }, 1500);
});
$(document).on("click", ".leadgen_main_popup [data-ldg-pincode-form-submit]", function () {
  setTimeout(() => {
    if(localStorage.customerPincode != currentPincode){
      currentPincode = localStorage.customerPincode;
      dataLayer.push({
        event: "pincode_interaction",
        page_type: document.body.dataset.page,
        section_name: $(this).closest(".ldg_store_popup_body").find("h3").text().trim(),
        cta_text: "Submit",
        // link_path: location.href,
        user_type_event: loggedin,
        User_ID_event: user_id,
        PC1: pc1,
        PC2: pc2,
      });
    }
  }, 1500);
});
$(document).on("click", ".pro-check-delivery [data-cd-pincode-form-submit]", function () {
  setTimeout(() => {
    if(localStorage.customerPincode != currentPincode){
      currentPincode = localStorage.customerPincode;
      dataLayer.push({
        event: "pincode_interaction",
        page_type: document.body.dataset.page,
        section_name: $(this).closest(".pro-check-delivery").find(".pro-check-delivery-title").text().trim(),
        cta_text: "Submit",
        // link_path: location.href,
        user_type_event: loggedin,
        User_ID_event: user_id,
        PC1: pc1,
        PC2: pc2,
      });
    }
  }, 1500);
});


// //42.remove_from_wishlist
// $(document).on("click", ".swymcs-wishlistplus-item-remove", function () {
//   dataLayer.push({
//     event: "remove_from_wishlist",
//     page_type: document.body.dataset.page,
//     PC1: pc1,
//     PC2: pc2,
//     currency: "INR",
//     value: parseInt($(this).closest(".swymcs-wishlistplus-item").find(".swymcs-product-final-price").text().trim().replace("₹","")),
//     item_name: $(this).closest(".swymcs-wishlistplus-item").find(".swymcs-wishlistplus-item-title").text().trim(),
//     item_id: $(this).closest(".swymcs-wishlistplus-item").attr("data-empi"),
//     item_brand: "BSC",
//     item_category: "NA",
//     item_category2: "NA",
//     item_category3: "NA",
//     item_category4: "NA",
//     item_category5: "NA",
//     price: parseInt($(this).closest(".swymcs-wishlistplus-item").find(".swymcs-product-final-price").text().trim().replace("₹","")),
//     discount: "NA",
//     item_list_name: "NA",
//     item_list_id: "NA",
//     item_variant: "NA",
//     index: $(this).closest(".swymcs-wishlistplus-item").index() + 1,
//     quantity: 1,
//     // link_path: location.href,
//     user_type_event: loggedin,
//     User_ID_event: user_id,
//   });
// });


// $(document).on("click", ".ProductItem .swym-button.swym-added", function () {

//   // document.body.classList.contains(`template-collection`)
//   let listName = $(`.collTitle`).text().trim();
//   let listID = $(`.collection-page-main`).parents(".shopify-section").attr("id");
//   if(!document.body.classList.contains(`template-collection`)){
//     listName = $(this).parents(".shopify-section").find(".SectionHeader__Heading").text().trim();
//     listID = $(this).parents(".shopify-section").attr("id");
//   }

//   console.log("swym remove");
//   dataLayer.push({
//     event: "remove_from_wishlist",
//     page_type: document.body.dataset.page,
//     PC1: pc1,
//     PC2: pc2,
//     currency: "INR",
//     value: parseInt($(this).closest(".ProductItem").find(".ProductItem__PriceList").text().trim().replace("₹","").replace(",","")),
//     item_name: $(this).closest(".ProductItem").find(".ProductItem__Title").text().trim(),
//     item_id: $(this).attr("data-product-id"),
//     item_brand: "BSC",
//     item_category: JSON.parse($(this).closest(".ProductItem").find(".ProductItem__ImageWrapper").attr("data-product")).product_type,
//     item_category2: "NA",
//     item_category3: "NA",
//     item_category4: "NA",
//     item_category5: "NA",
//     price: parseInt($(this).closest(".ProductItem").find(".ProductItem__PriceList").text().trim().replace("₹","").replace(",","")),
//     discount: "NA",
//     item_list_name: listName,
//     item_list_id: listID,
//     item_variant: "NA",
//     index: $(this).closest(".ProductItem").parent("div").index() + 1,
//     quantity: 1,
//     // link_path: location.href,
//     user_type_event: loggedin,
//     User_ID_event: user_id,
//   });
// });


//42.logout_click
$(document).on("click", ".drawer-logout", function () {
  dataLayer.push({
    event: "logout_click",
    page_type: document.body.dataset.page,
    // link_path: location.href,
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

//43.myOrder_interaction
$(document).on("click", ".customers-order .dropdown-toggle.click-dropdown, .customers-order .dropdown-menu ul li", function () {
  dataLayer.push({
    event: "myOrder_interaction",
    page_type: document.body.dataset.page,
    section_name: $(".customers-order .SectionHeader__Heading").text().trim(),
    selection_type: $(this).text().trim(),
    user_type_event: loggedin,
    User_ID_event: user_id,
    PC1: pc1,
    PC2: pc2,
  });
});

// //44.screenshot_capture
// document.addEventListener("visibilitychange", function () {
//     if (document.visibilityState === "hidden") {

//       let product_name = "NA";
//       if(document.body.classList.contains("template-product")){
//         product_name = $(`body.template-product #main .Product__Info .ProductMeta__Title`).text().trim();
//       }
//       dataLayer.push({
//         event: "screenshot_capture",
//         page_type: document.body.dataset.page,
//         product_name: product_name,
//         // link_path: location.href,
//         user_type_event: loggedin,
//         User_ID_event: user_id,
//         PC1: pc1,
//         PC2: pc2,
//       });
//     }
// });
